import {
    Grid,
    Typography,
    withStyles,
    Theme,
    Button,
    TextField,
    FormControlLabel,
    Checkbox,
    RadioGroup,
    Radio,
    Box,
    CircularProgress,
    useMediaQuery,
    DialogTitle,
    IconButton,
} from '@material-ui/core'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import MuiDialog from '@material-ui/core/Dialog'
import MuiDialogContent from '@material-ui/core/DialogContent'
//import DialogContent from '@material-ui/core/DialogContent'
// import fileDownload from 'js-file-download'
// import BulbOutlineIcon from 'mdi-react/BulbOutlineIcon'
import ChevronRightIcon from 'mdi-react/ChevronRightIcon'
import ChevronLeftIcon from 'mdi-react/ChevronLeftIcon'
// import DownloadIcon from 'mdi-react/DownloadIcon'

import { useEffect, useState, useCallback, useLayoutEffect, Fragment } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom'
import { Dispatch } from 'redux'
import { reduxForm, change, formValueSelector } from 'redux-form'
import { stepAfterShowingForward } from '../../actions/apartments'
// import {
//     ReduxFormField
// } from '../../components/FormInput/ReduxWrappers'
import LoadingContainer from '../../components/LoadingContainer/LoadingContainer'
import Api from '../../services/applications'
import i18n from '../../translations/i18n'
import { MuiClasses } from '../../types'
// import { ApartmentInformation, DropDownItem } from '../../types/apartments'
// import { AutocompleteOption } from '../../types/autocomplete'
// import { ReduxForm } from '../../types/forms'
// import { WaterFeeBasis } from '../../types/propValues/apartments'
import { StateInterface } from '../../types/states';
import { validateForm, generateValidationSchema } from '../../utils/validation/contractGenerator'
//import { MyInput } from '../NewApplication/Fields'
import { getCurrentUserInfo } from '../../services/auth/auth'
import ShowingsApi from '../../services/showings'
import ReduxDatePicker from '../../components/FormInput/ReduxWrappers/ReduxDatePicker';
import '../PayForPublish/ContractGenerator.css';
import Suggest from '../Apartment/Stepper/Steps/Suggest'
import PlusIcon from '../../images/contractGenerator/plus.svg'
import SignatureIcon from '../../images/contractGenerator/signature.svg'
import DownloadIcon from '../../images/contractGenerator/download.svg'
import { toast } from 'react-toastify'
//import Dialog from '../Dialog'
import PaymentPopup from '../PayForPublish/PaymentPopup'
import ContractGeneratorDigivakuusStep from './Steps/ContractGeneratorDigivakuusStep'
import CloseIcon from '@material-ui/icons/Close'

const styles = ({ breakpoints, typography }: Theme) => ({
    // customSuggestTextStyles: {
    //     fontSize: '1.125rem',
    //     fontWeight: typography.fontWeightLight,
    //     fontFamily: 'CircularRegular',
    //     fontStyle: 'normal',
    //     maxWidth: '97%',
    //     margin: '0.2rem auto',
    //     marginLeft: '1rem',
    //     lineHeight: '1.625rem',
    //     textAlign: 'left !important',
    //     [breakpoints.down('sm')]: {
    //         maxWidth: '100%',
    //         lineHeight: '1.1',
    //         fontSize: typography.pxToRem(28)
    //     }
    // },
    noPrint: {
        '@media print': {
            display: 'none !important',
        },
    },
    addAnotherLandlordButton: {
        display: 'flex',
        height: '3.75rem',
        padding: '1rem 1.5rem',
        alignItems: 'center',
        gap: '0.75rem',
        fontWeight: 'bold',
        border: '1px dashed #D3D5D7',
        fontSize: '1.2rem !important',
        [breakpoints.down('sm')]: {
            fontSize: '0.9rem !important',
            height: 'auto !important',
        },
        borderRadius: '0.625rem'
    },
    errorText: {
        color: '#f44336;',
    },
    subHeading: {
        marginTop: '1.9rem'
    },
    subHeadingAfterDisclaimer: {
        marginTop: '1.5rem'
    },
    formContainer: {
        // padding: '35px 0 15px 0',
        // maxWidth: '550px',
        maxWidth: '1131px',
        width: '80%',
        margin: 'auto',
        padding: '2rem 0',
        [breakpoints.down('sm')]: {
            width: '100%',
            margin: '0 auto 0em',
            padding: '0.5rem 0 0rem'
        }
    },
    modalMobile: {
        [breakpoints.down('sm')]: {
            margin: '20px'
        }
    },
    roundedInput: {
        borderRadius: '0.625rem', // adjust as needed
    },
    paymentOption: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        flexWrap: 'wrap',
        marginTop: '30px'
    } as const,
    paymentCard: {
        // width: '23% '
    },
    buttons: {
        margin: '2rem 0 2rem 0',
        width: '100%',
        [breakpoints.down('sm')]: {
            position: 'fixed',
            bottom: 0,
            margin: 0,
            backgroundColor: '#fff',
            padding: '10px'
        }
    },
    button: {
        // width: '48%',
        [breakpoints.down('sm')]: {
            borderRadius: 0
        }
    },
    buttonGridContainer: {
        width: '47.5%'
    },
    clauses: {
        margin: '0 !important',
        borderRadius: '1.25rem',
        background: '#F7F8F9',
        color: '#2F2F2F',
        padding: '1.3rem 1.5rem',
        gap: '0.75rem',
        width: '100%',
        boxSizing: 'border-box', // Add this line
    },
    cancelTextButton: {
        color: '#D43838',
        fontSize: '1.375rem',
        height: '65px',
        textTransform: 'none' as const,
        background: 'none',
        boxShadow: 'none',
        fontWeight: 'bold' as const,
        backgroundColor: '#fff',
        '&:hover': {
            background: 'none',
            boxShadow: 'none'
        },
        [breakpoints.down('sm')]: {
            // marginBottom: '100px'
        }
    },
    responsiveWidth: {
        [breakpoints.down('sm')]: {
            padding: '0 1rem'
        }
    },
    bottomButton: {
        borderRadius: '0.625rem',
        [breakpoints.down('sm')]: {
            height: 'auto !important',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
        },
    },
    bottomButton1: {
        color: '#2F2F2F',
        [breakpoints.up('sm')]: {
            marginRight: '0.2rem',
            width: '99%'
        }
    },
    bottomButton2: {
        [breakpoints.up('sm')]: {
            marginLeft: '0.2rem',
            width: '99%'
        }
    },
    bottomButton1ContractPart: {
        color: '#2F2F2F',
        [breakpoints.up('md')]: {
            marginRight: '0.2rem',
            width: '99%'
        }
    },
    bottomButton2ContractPart: {
        [breakpoints.up('md')]: {
            marginLeft: '0.2rem',
            width: '99%'
        }
    },
    leaseContainer: {
        marginTop: '4rem',
        marginBottom: '4.5rem',
        [breakpoints.down('sm')]: {
            marginTop: '3.2rem',
            marginBottom: '2.25rem'
        }
    },
    moversSection: {
        marginTop: '3.6rem',
        [breakpoints.down('sm')]: {
            marginTop: '2rem'
        }
    },
    moversContainer: {
        padding: '40px 30px 47px 41px',
        borderRadius: '20px',
        [breakpoints.down('sm')]: {
            padding: '32px 30px 43px 30px'
        }
    },
    leaseDurationTitle: {
        marginBottom: '2rem',
        [breakpoints.down('sm')]: {
            marginBottom: '1.625rem'
        }
    },
    moversTitle: {
        marginBottom: '1.6rem',
        [breakpoints.down('sm')]: {
            marginBottom: '1.875rem'
        }
    },
    moversField: {
        margin: '1.4rem auto 1.2rem auto',
        '& .react-select__control': {
            padding: '2px 8px',
            borderRadius: '8px'
        },
        '& .react-select__placeholder': {
            fontSize: '16px'
        },
        [breakpoints.down('sm')]: {
            margin: '1.8rem auto 1.625rem auto'
        }
    },
    inlineDatePicker: {
        // border: '2px solid red',
        borderRadius: '8px'
    },
    labelText: {
        fontSize: typography.pxToRem(18)
    },
    formLabel: {
        fontSize: typography.pxToRem(20),
        [breakpoints.down('sm')]: {
            fontSize: typography.pxToRem(16),
            marginBottom: '8px'
        }
    },
    calendarInputContainer: {
        padding: '25px 32px 29px 32px',
        [breakpoints.down('sm')]: {
            // padding: '36px 16px 37px 42px'
            padding: '36px 25px 37px 25px;',
            marginBottom: '20px'
        }
    },
    containerStyle: {
        marginLeft: '30px',
        [breakpoints.down('sm')]: {
            marginLeft: '0px'
        }
    },
    sartDateRow: {
        height: '178px',
        alignItems: 'center',
        [breakpoints.down('sm')]: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
        }
    },
    stepTwoInfo: {
        '> div': {
            display: 'flex'
        },
        [breakpoints.down('sm')]: {
            display: 'flex',
            flexDirection: 'column'
        }
    },
    stepTwoInfoDetails: {
        display: 'flex',
        [breakpoints.down('sm')]: {
            display: 'flex',
            flexDirection: 'column'
        }
    },
    dialogContanier: {
        paddingTop: '3.875rem',
        paddingBottom: '3.875rem'
    },
    authPrompt: {
        padding: '54px 0',
        marginTop: '55px',
        [breakpoints.down('sm')]: {
            padding: '84px 0'
        }
    },
    applicantInfo: {
        // padding: '54px 0',
        marginTop: '51px',
        [breakpoints.down('sm')]: {
            padding: '2rem 0',
            marginBottom: '7rem'
        }
    },
    authDesc: {
        marginTop: '2rem',
        marginBottom: '3.375rem'
    },
    requiredField: {
        '&:after': {
            content: '"*"',
            color: 'red'
        }
    },
    labelChecker: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        padding: '10px 0',
        [breakpoints.down('sm')]: {
            padding: '15px',
            paddingLeft: '2em',
            paddingRight: '1em',
            marginRight: '0'
        }
    },
    heading: {
        textAlign: 'center',
        marginBottom: '1rem',
        [breakpoints.down('sm')]: {
            fontSize: '1.6rem'
        }
    },
    mBottom: {
        marginBottom: '10px'
    },
    suggestIcon: {
        objectFit: 'contain',
        width: '30px',
        [breakpoints.down('sm')]: {
            marginBottom: '10px'
        }
    } as const,
    paragraphStyle: {
        fontSize: '1.1rem',
        '& span': {
            color: '#94004A'
        },
        [breakpoints.down('sm')]: {
            marginRight: '10px',
            marginLeft: '20px'
        }
    },
    modalSecondaryButton: {
        marginTop: '20px'
    },
    contractFormContainer: {
        backgroundColor: '#F7F8F9',
        borderRadius: '1.25rem',
        padding: '2rem',
        [breakpoints.down('sm')]: {
            padding: '0.35rem'
        }
    },
    firstOnLarge: {
        order: 1,
        [breakpoints.down('sm')]: {
            order: 3,
        },
    },
    secondOnLarge: {
        order: 2,
        [breakpoints.down('sm')]: {
            order: 1,
        },
    },
    thirdOnLarge: {
        order: 3,
        [breakpoints.down('sm')]: {
            order: 2,
        },
    },
    arrowIcon: {
        [breakpoints.down('sm')]: {
            marginTop: '-5px',
        },
    },
    clauseContainer: {
        '& p': {
            lineHeight: '1.4',
        },
    },
    dialogCloseButton: {
        color: '#94004A',
        fontSize: '2rem',
        fontWeight: 400,
        position: 'absolute',
        right: 8,
        top: 8,
        caretColor: 'transparent'
    },
})

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 560,
        backgroundColor: theme.palette.background.paper
    },
    paper: {
        width: '90%',
        borderRadius: 35
    }
}))

export interface ContractGeneratorFormProps {
    classes: MuiClasses
    t: i18n.TFunction
    currentStep: number
    /** Call this from inside the form to set total steps (e.g., 3 or 4) */
    numberOfSteps: (n: number) => void
}
const ContractGeneratorForm = ({
    classes,
    t,
    currentStep,
    numberOfSteps
}: ContractGeneratorFormProps) => {

    const theme = useTheme()
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))

    const allClauses = [
        { text: t('contractCreator.terms.generalTerms'), isUndeselectable: true, original: true },
        { text: t('contractCreator.terms.contractArchive'), isUndeselectable: true, original: true },
        { text: t('contractCreator.terms.tenantTerminationNotice'), isUndeselectable: true, original: true },
        { text: t('contractCreator.terms.landlordTerminationNotice'), isUndeselectable: true, original: true },
        { text: t('contractCreator.terms.startAndLeaveCheck'), isUndeselectable: true, original: true },
        { text: t('contractCreator.terms.movingDate'), isUndeselectable: false, original: true },
        { text: t('contractCreator.terms.insuranceRequirement'), isUndeselectable: false, original: true },
        { text: t('contractCreator.terms.lettingRestriction'), isUndeselectable: false, original: true },
        { text: t('contractCreator.terms.waterFeeAdjustment'), isUndeselectable: false, original: true },
        { text: t('contractCreator.terms.latePaymentInterest'), isUndeselectable: false, original: true },
        { text: t('contractCreator.terms.ventilationGuideline'), isUndeselectable: false, original: true },
        { text: t('contractCreator.terms.rentalCondition'), isUndeselectable: false, original: true },
        { text: t('contractCreator.terms.noSmoking'), isUndeselectable: false, original: true },
        { text: t('contractCreator.terms.securityDeposit'), isUndeselectable: false, original: true },
        { text: t('contractCreator.terms.rentPayment'), isUndeselectable: false, original: true },
        { text: t('contractCreator.terms.kelaFundsStraightToLandlord'), isUndeselectable: false, original: true },
        { text: t('contractCreator.terms.keyReturn'), isUndeselectable: false, original: true },
        { text: t('contractCreator.terms.smokeAlarmRequirement'), isUndeselectable: false, original: true },
        { text: t('contractCreator.terms.repairRestriction'), isUndeselectable: false, original: true },
        { text: t('contractCreator.terms.drillingRestriction'), isUndeselectable: false, original: true },
        { text: t('contractCreator.terms.damageNotification'), isUndeselectable: false, original: true },
        { text: t('contractCreator.terms.apartmentInspection'), isUndeselectable: false, original: true },
        { text: t('contractCreator.terms.annualRentIncrease'), isUndeselectable: false, original: true },
        { text: t('contractCreator.terms.tenantMakesElectricityContract'), isUndeselectable: false, original: true },
        { text: t('contractCreator.terms.petsDisallowed'), isUndeselectable: false, original: true },
        { text: t('contractCreator.terms.petDamageDisclaimer'), isUndeselectable: false, original: true },
        { text: t('contractCreator.terms.fineForNotStartingRent'), isUndeselectable: false, original: true },
        { text: t('contractCreator.terms.moveNoticeObligation'), isUndeselectable: false, original: true },
    ]

    const firstDismissalTerminationClause = {
        text: t('contractCreator.terms.breachOfAgreement'),
        isUndeselectable: false,
        original: true
    };

    const tenantTerminationClause = {
        text: t('contractCreator.terms.tenantTerminationNotice'),
        isUndeselectable: true,
        original: true
    };

    const landlordTerminationClause = {
        text: t('contractCreator.terms.landlordTerminationNotice'),
        isUndeselectable: true,
        original: true
    };

    const initialClauses = [
        //firstDismissalTerminationClause,
        // tenantTerminationClause,
        // landlordTerminationClause,
        ...allClauses.filter(clause => clause.isUndeselectable),
    ];

    const history = useHistory()
    const routeMatch = useRouteMatch()
    const applicationCode = (routeMatch.params as any).applicationCode
    const location = useLocation()
    const [isLoading, setLoading] = useState(false)
    const [userAttributes, setUserAttributes] = useState(null);
    const [apartment, setApartment] = useState(null);
    const [application, setApplication] = useState(null);
    const [autoDownloaded, setAutoDownloaded] = useState(false)
    const [contract, setContract] = useState({
        landlord: {},
        additionalLandlords: [],
        tenants: [],
        selectedClauses: initialClauses,
        details: {
            digivakuusDepositAccepted: false,
            digivakuusEscrowService: false,
            ropoRentChargingServiceAccepted: false
        },
        language: i18n.language,
        identifiers: {
            applicationId: '',
            apartmentId: '',
            apartmentUserId: '',
        },
        apartment: {},
        leea: true
    });
    const [clauses, setClauses] = useState(allClauses);
    const [customClause, setCustomClause] = useState('');
    const [formErrors, setFormErrors] = useState({});
    const [digivakuusDepositAccepted, setDigivakuusDepositAccepted] = useState(false);
    const [digivakuusEscrowServiceAccepted, setDigivakuusEscrowServiceAccepted] = useState(false);
    const [ropoRentChargingServiceAccepted, setRopoRentChargingServiceAccepted] = useState(false);
    const [applicantIsDigivakuusVerified, setApplicantIsDigivakuusVerified] = useState(true);
    const [showExistingDigivakuusProducts, setShowExistingDigivakuusProducts] = useState(false);
    //const [isInternalNavigation, setIsInternalNavigation] = useState(false);
    const navigateTo = useCallback(
        (newStep) => {
            history.push(`/users/${apartment.userId}/apartments/${apartment.apartmentId}/contract/${applicationCode}/steps/${newStep}`)
        },
        [history, routeMatch]
    )

    const hasRight = (apt: any, rightId: string) =>
        Array.isArray(apt?.rights) && apt.rights.includes(rightId)

    const needsGenerate = !hasRight(apartment, '5')
    const needsSigning = !hasRight(apartment, '6')

    const [openBuyGenerate, setOpenBuyGenerate] = useState(false)

    const onGenerateClick = (e?: any) => {
        e?.preventDefault?.()

        // If they already own the generateContract right, just generate
        if (hasRight(apartment, '5')) {
            generatePDFWithValidation()
            return
        }

        // Otherwise validate first; errors will render on the page
        if (!validateBeforePurchase()) {
            setOpenBuyGenerate(false)
            return
        }

        // Valid -> open purchase dialog for generateContract
        setOpenBuyGenerate(true)
    }

    const onSendForSigningClick = (e?: any) => {
        e?.preventDefault?.()

        // If they already have signing -> just send
        if (Array.isArray(apartment?.rights) && apartment.rights.includes('6')) {
            sendForSigning()
            return
        }

        // Validate first; errors will show on the page
        if (!validateBeforePurchase()) {
            setOpenPay(false)
            return
        }

        setOpenPay(true)
    }

    const productTags: string[] = []
    if (needsGenerate) productTags.push('generateContract')
    if (needsSigning) productTags.push('enableOnlineSigning')
    useEffect(() => {
        if (application && application.contract) {
            setContract(application.contract)
            const details = application.contract.details || {}
            setDigivakuusDepositAccepted(Boolean(details.digivakuusDepositAccepted))
            setDigivakuusEscrowServiceAccepted(Boolean(details.digivakuusEscrowService))
            setRopoRentChargingServiceAccepted(Boolean(details.ropoRentChargingServiceAccepted))
            let updatedClauses = clauses;
            application.contract.selectedClauses.forEach((selectedClause) => {
                if (!updatedClauses.some((clause) => clause.text === selectedClause.text)) {
                    updatedClauses.push(selectedClause);
                }
            });

            if (application.contract.details.fixedTermPeriod) {
                updatedClauses = updatedClauses.filter(
                    (clause) =>
                        clause.text !== t('contractCreator.terms.tenantTerminationNotice') &&
                        clause.text !== t('contractCreator.terms.landlordTerminationNotice')
                )
            }

            setClauses(updatedClauses);
        }

        if (application && application.applicants && application.applicants.length > 0) {
            const isApplicable = application.applicants.some((applicant) => {
                const accepted = applicant.acceptedDigivakuusDepositService === true
                const eligible = applicant.digivakuusEligibility === true
                return accepted && eligible
            })
            setShowExistingDigivakuusProducts(isApplicable)
        } else {
            setShowExistingDigivakuusProducts(false)
        }
    }, [application])

    useEffect(() => {
        setContract(prev => ({
            ...prev,
            details: {
                ...prev.details,
                digivakuusDepositAccepted,
                digivakuusEscrowService: digivakuusEscrowServiceAccepted,
                ropoRentChargingServiceAccepted
            }
        }))
    }, [digivakuusDepositAccepted, digivakuusEscrowServiceAccepted, ropoRentChargingServiceAccepted])

    // useEffect(() => {
    //     // only act if redirected with the success flag
    //     const params = new URLSearchParams(location.search);
    //     const isOk = params.get('status') === 'generateContractOk';
    //     if (!isOk || autoDownloaded) return;

    //     // wait until we actually have data
    //     if (!apartment || !contract) return;

    //     // user already owns the right -> use your existing logic
    //     if (hasRight(apartment, '5')) {
    //         generatePDFWithValidation();
    //         setAutoDownloaded(true);

    //         // optional: clean the query so it won’t re-trigger on refresh
    //         const next = new URLSearchParams(location.search);
    //         next.delete('status');
    //         history.replace({ ...location, search: next.toString() });
    //     }
    // }, [location.search, apartment?.rights, contract, autoDownloaded]);

    const navigateStep1To2 = useCallback(
        () => { // removed newStep parameter
            //console.log(initialclauses);

            const formData = {
                fixedTermPeriod: contract.details.fixedTermPeriod,
                startDate: contract.details.startDate,
                iban: contract.landlord.iban,
                rentPaymentDay: contract.details.rentPaymentDay,
                numberOfKeys: contract.details.numberOfKeys,
                landlordAddress: contract.landlord.address,
                // landlordStreet: contract.landlord.street,
                // landlordPostalCode: contract.landlord.postalCode,
                // landlordCity: contract.landlord.city,
                // other fields...
            };

            // Conditionally adding firstDismissalDate to formData
            if (contract.details.firstDismissal) {
                formData.firstDismissalDate = contract.details.firstDismissalDate;
            }

            // Conditionally adding availableUntilDate to formData
            if (contract.details.fixedTermPeriod) {
                formData.availableUntilDate = contract.details.availableUntilDate;
            }

            if (contract.additionalLandlords && contract.additionalLandlords.length > 0) {
                contract.additionalLandlords.forEach((landlord, index) => {
                    formData[`additionalLandlordName${index}`] = landlord.name;
                    formData[`additionalLandlordEmail${index}`] = landlord.email;
                });
            }

            const schema = generateValidationSchema(contract);
            const errors = validateForm(formData, schema);

            setFormErrors(errors);

            // Check if there are any validation errors
            if (Object.keys(errors).length > 0) {
                return;
            }
            //setIsInternalNavigation(true);
            // There are no validation errors, navigate to step 2
            // const newAddress = `${contract.landlord.street}, ${contract.landlord.postalCode} ${contract.landlord.city}`;
            // setContract(prevContract => ({
            //     ...prevContract,
            //     landlord: {
            //         ...prevContract.landlord,
            //         address: newAddress
            //     }
            // }));
            history.push(`/users/${application.apartmentUserId}/apartments/${application.apartmentId}/contract/${applicationCode}/steps/2`) // replaced newStep with 2
        },
        [history, routeMatch, contract]
    )

    function replacePlaceholderWithNumberOfKeys() {
        const originalText = t('contractCreator.terms.movingDate');
        // Perform the replacement and return the new string
        return originalText.replace('_', contract.details.numberOfKeys.toString());
    }
    function replacePlaceholderWithAddressAndTenantName(originalText) {
        let replacementCount = 0;

        // Replacement values
        const firstReplacement = contract.apartment.address;
        const secondReplacement = contract.tenants[0].name;

        return originalText.replace(/_/g, () => {
            replacementCount++;
            return replacementCount === 1 ? firstReplacement : secondReplacement;
        });
    }

    function updateNumberOfKeys() {
        if (contract.details.numberOfKeys) {
            let updatedSelectedClauses = [...contract.selectedClauses];
            let updatedClauses = [...clauses];

            const translationString = t('contractCreator.terms.movingDate'); // or your specific string
            const comparisonString = translationString.substring(0, 20);
            updatedSelectedClauses = updatedSelectedClauses.map(clause => {
                if (clause.text.substring(0, 20) === comparisonString) {
                    return {
                        ...clause,
                        text: replacePlaceholderWithNumberOfKeys()
                    };
                }
                return clause;
            });

            updatedClauses = updatedClauses.map(clause => {
                if (clause.text.substring(0, 20) === comparisonString) {
                    return {
                        ...clause,
                        text: replacePlaceholderWithNumberOfKeys()
                    };
                }
                return clause;
            });
            setContract(prevState => ({
                ...prevState,
                selectedClauses: updatedSelectedClauses
            }));
            setClauses(updatedClauses);
        }
    }

    function updateTextInfo() {
        if (contract.apartment.address && contract.tenants && contract.tenants.length > 0) {
            let updatedSelectedClauses = [...contract.selectedClauses];
            let updatedClauses = [...clauses];

            const rentPaymentString = t('contractCreator.terms.rentPayment');
            const securityDepositString = t('contractCreator.terms.securityDeposit');
            const rentPaymentComparisonString = rentPaymentString.substring(0, 20);
            const securityDepositComparisonString = securityDepositString.substring(0, 80);

            const updateClauseText = (clause, comparisonString, translationString) => {
                if (clause.original && clause.text.substring(0, 80) === comparisonString) {
                    return {
                        ...clause,
                        text: replacePlaceholderWithAddressAndTenantName(translationString)
                    };
                }
                return clause;
            };

            updatedSelectedClauses = updatedSelectedClauses.map(clause => updateClauseText(clause, rentPaymentComparisonString, rentPaymentString));
            updatedClauses = updatedClauses.map(clause => updateClauseText(clause, rentPaymentComparisonString, rentPaymentString));

            updatedSelectedClauses = updatedSelectedClauses.map(clause => updateClauseText(clause, securityDepositComparisonString, securityDepositString));
            updatedClauses = updatedClauses.map(clause => updateClauseText(clause, securityDepositComparisonString, securityDepositString));

            setContract(prevState => ({
                ...prevState,
                selectedClauses: updatedSelectedClauses
            }));
            setClauses(updatedClauses);
        }
    }

    function handleFirstDismissal(momentValue) {
        let updatedSelectedClauses = [...contract.selectedClauses]
        let updatedClauses = [...clauses]

        if (momentValue) {
            if (!updatedSelectedClauses.some(clause => clause.text === firstDismissalTerminationClause.text)) {
                updatedSelectedClauses.push(firstDismissalTerminationClause)
            }
            if (!updatedClauses.some(clause => clause.text === firstDismissalTerminationClause.text)) {
                updatedClauses.push(firstDismissalTerminationClause)
            }
        } else {
            updatedSelectedClauses = updatedSelectedClauses.filter(
                clause => clause.text !== firstDismissalTerminationClause.text
            )
            updatedClauses = updatedClauses.filter(
                clause => clause.text !== firstDismissalTerminationClause.text
            )
        }

        setContract(prevState => ({
            ...prevState,
            selectedClauses: updatedSelectedClauses
        }))
        setClauses(updatedClauses)
    }

    function updateClauses(isFixedTerm) {
        let updatedSelectedClauses = [...contract.selectedClauses]
        let updatedClauses = [...clauses]

        if (!isFixedTerm && contract.details.firstDismissalDate) {
            if (!updatedSelectedClauses.some(clause => clause.text === firstDismissalTerminationClause.text)) {
                updatedSelectedClauses.push(firstDismissalTerminationClause)
            }
            if (!updatedClauses.some(clause => clause.text === firstDismissalTerminationClause.text)) {
                updatedClauses.push(firstDismissalTerminationClause)
            }
        } else {
            updatedSelectedClauses = updatedSelectedClauses.filter(
                clause => clause.text !== firstDismissalTerminationClause.text
            )
            updatedClauses = updatedClauses.filter(
                clause => clause.text !== firstDismissalTerminationClause.text
            )
        }

        if (!isFixedTerm) {
            if (!updatedSelectedClauses.some(clause => clause.text === tenantTerminationClause.text)) {
                updatedSelectedClauses.push(tenantTerminationClause)
            }
            if (!updatedClauses.some(clause => clause.text === tenantTerminationClause.text)) {
                updatedClauses.push(tenantTerminationClause)
            }

            if (!updatedSelectedClauses.some(clause => clause.text === landlordTerminationClause.text)) {
                updatedSelectedClauses.push(landlordTerminationClause)
            }
            if (!updatedClauses.some(clause => clause.text === landlordTerminationClause.text)) {
                updatedClauses.push(landlordTerminationClause)
            }
        } else {
            updatedSelectedClauses = updatedSelectedClauses.filter(clause => clause.text !== tenantTerminationClause.text)
            updatedClauses = updatedClauses.filter(clause => clause.text !== tenantTerminationClause.text)

            updatedSelectedClauses = updatedSelectedClauses.filter(clause => clause.text !== landlordTerminationClause.text)
            updatedClauses = updatedClauses.filter(clause => clause.text !== landlordTerminationClause.text)
        }

        setContract(prevState => ({
            ...prevState,
            selectedClauses: updatedSelectedClauses
        }))

        setClauses(updatedClauses)
    }


    //THIS IS THE ISSUE WITH selectedclauses on non page reload component load
    // useEffect(() => {
    //     updateClauses();
    // }, [contract.details.fixedTermPeriod, contract.details.firstDismissal]);

    useEffect(() => {
        updateTextInfo();
    }, [contract.apartment, contract.tenants, contract.landlord, contract.details]);

    useEffect(() => {
        updateNumberOfKeys();
    }, [contract.details.numberOfKeys]);

    //necessary for keeping the order of the clauses on step 3
    useEffect(() => {
        const sortedClauses = contract.selectedClauses.sort((a, b) => {
            const indexA = clauses.findIndex(clause => clause.text === a.text)
            const indexB = clauses.findIndex(clause => clause.text === b.text)
            return indexA - indexB
        })

        setContract(prevState => ({
            ...prevState,
            selectedClauses: sortedClauses
        }))
    }, [contract.selectedClauses, clauses])

    const addOtherLandlord = () => {
        setContract(prevContract => {
            const newLandlord = {
                id: Math.random(),
                name: "",
                email: "",
            };
            return { ...prevContract, additionalLandlords: [...prevContract.additionalLandlords, newLandlord] };
        });
    };

    useLayoutEffect(() => {
        const scrollContainer = document.querySelector('.scrollToTopTarget');
        if (scrollContainer) {
            scrollContainer.scrollIntoView({ behavior: "smooth", block: "end" });;
        }
    }, [location.pathname])

    useEffect(() => {
        if (userAttributes && application && !application.contract && apartment) {
            setContract(prevContract => {
                let securityDepositAmount = apartment.confirmation.securityDepositAmount
                if (!securityDepositAmount && apartment.confirmation.price) {
                    const depositMultipliers = {
                        "zero": 0,
                        "oneMonth": 1,
                        "twoMonths": 2,
                        "threeMonths": 3
                    }
                    const multiplier = depositMultipliers[apartment.confirmation.securityDeposit]
                    securityDepositAmount = `${apartment.confirmation.price * multiplier || ''}`
                }

                let newContract = {
                    ...prevContract,
                    landlord: {
                        ...prevContract.landlord,
                        ...(userAttributes.name && !prevContract.landlord?.name && { name: userAttributes.name }),
                        ...(userAttributes.phone_number &&
                            !prevContract.landlord?.phone && {
                            phone: !userAttributes.phone_number.startsWith('0') && !userAttributes.phone_number.startsWith('+')
                                ? `+${userAttributes.phone_number}`
                                : userAttributes.phone_number
                        }),
                        ...(userAttributes.email && !prevContract.landlord?.email && { email: userAttributes.email })
                    },
                    tenants: application?.applicants?.map(applicant => {
                        const existingTenant = prevContract.tenants?.find(t => t.idNumber === applicant.idNumber)
                        return {
                            ...(existingTenant || {}),
                            ...(applicant.name && !existingTenant?.name && { name: applicant.name }),
                            ...(applicant.idNumber && !existingTenant?.idNumber && { idNumber: applicant.idNumber }),
                            ...(applicant.phone && !existingTenant?.phone && {
                                phone: applicant.phone.startsWith('0') || applicant.phone.startsWith('+')
                                    ? applicant.phone
                                    : `+${applicant.phone}`
                            }),
                            ...(applicant.address && !existingTenant?.address && { address: `${applicant.address || ''}, ${applicant.postalCode || ''} ${applicant.postalArea || ''}` }),
                            ...(applicant.email && !existingTenant?.email && { email: applicant.email }),
                            ...(applicant.addedManually && !existingTenant?.addedManually && { addedManually: true })
                        }
                    }),
                    apartment: {
                        ...prevContract.apartment,
                        ...(apartment.information.address && !prevContract.apartment?.address && { address: `${apartment.information.address || ''}, ${apartment.information.postalCode || ''} ${apartment.information.postalArea || ''}` }),
                        ...(apartment.information.buildingType && !prevContract.apartment?.buildingType && { buildingType: translateBuildingType(apartment.information.buildingType) }),
                        ...(apartment.information.squareMeters && !prevContract.apartment?.squareMeters && { squareMeters: apartment.information.squareMeters }),
                        ...(apartment.information.buildYear && !prevContract.apartment?.buildYear && { buildYear: apartment.information.buildYear }),
                        ...(apartment.information.condition && !prevContract.apartment?.condition && { condition: translateCondition(apartment.information.condition) })
                    },
                    details: {
                        ...prevContract.details,
                        ...(apartment.confirmation.rentPeriod !== 'formerlyValid' && !prevContract.details?.fixedTermPeriod && { fixedTermPeriod: true }),
                        ...(apartment.confirmation.price && !prevContract.details?.rentAmount && { rentAmount: `${apartment.confirmation.price || ''}` }),
                        ...(securityDepositAmount && !prevContract.details?.securityDepositAmount && { securityDepositAmount }),
                        ...(apartment.confirmation.waterFee && !prevContract.details?.waterFee && { waterFee: `${apartment.confirmation.waterFee}${apartment.confirmation.waterFeeBasis ? ' / ' + translateWaterFeeBasis(apartment.confirmation.waterFeeBasis) : ''}` }),
                        ...(apartment.confirmation.waterFeeBasis && !apartment.confirmation.waterFee && !prevContract.details?.waterFee && { waterFee: translateWaterFeeBasis('byUsage') }),
                        ...(application.data.readyForMoveDate && !prevContract.details?.startDate && { startDate: `${application.data.readyForMoveDate || ''}` }),
                        ...(apartment.confirmation.availableUntilDate && !prevContract.details?.availableUntilDate && { availableUntilDate: apartment.confirmation.availableUntilDate })
                    },
                    identifiers: {
                        ...prevContract.identifiers,
                        applicationId: prevContract.identifiers?.applicationId || application.applicationId,
                        apartmentId: prevContract.identifiers?.apartmentId || application.apartmentId,
                        apartmentUserId: prevContract.identifiers?.apartmentUserId || application.apartmentUserId
                    }
                }

                if (apartment.noticeTime && !prevContract.details?.firstDismissal) {
                    newContract.details.firstDismissal = true
                } else if (!apartment.noticeTime && !prevContract.details?.firstDismissal) {
                    newContract.details.firstDismissal = false
                }

                if (!prevContract.apartment?.layout) {
                    newContract.apartment.layout = constructLayout(apartment)
                }

                // ✅ Ensure leea is always true
                newContract.leea = true;

                return newContract
            })
        }
    }, [userAttributes, application, apartment])

    useEffect(() => {
        numberOfSteps(4)
    }, [numberOfSteps])

    function constructLayout(apartment) {
        let layoutParts = [];

        // Adding rooms
        const roomsKey = `contractCreator.rooms.${apartment.information.rooms}`;
        let roomsTranslation = t(roomsKey);
        if (roomsTranslation !== roomsKey) {
            layoutParts.push(roomsTranslation);
        }

        // Adding kitchen
        const kitchenKey = `contractCreator.kitchen.${apartment.information.kitchen}`;
        let kitchenTranslation = t(kitchenKey);
        if (kitchenTranslation !== kitchenKey) {
            layoutParts.push(kitchenTranslation);
        }

        // Adding balcony
        if (apartment.information.balcony && apartment.information.balcony !== 'no' && apartment.information.balcony !== false) {
            const balconyKey = `contractCreator.balcony.${apartment.information.balcony}`;
            let balconyTranslation = t(balconyKey);
            if (balconyTranslation === balconyKey) {
                balconyTranslation = t('contractCreator.balcony.label');
            }
            layoutParts.push(balconyTranslation);
        }

        // Adding sauna
        if (apartment.information.sauna && apartment.information.sauna !== 'no' && apartment.information.sauna !== false) {
            layoutParts.push("sauna");
        }

        return layoutParts.join(" + ");
    }

    function translateBuildingType(buildingType) {
        const buildingTypeKey = `apartment.buildingType.${buildingType}`;
        let buildingTypeTranslation = t(buildingTypeKey);

        return buildingTypeTranslation !== buildingTypeKey ? buildingTypeTranslation : buildingType;
    }

    function translateCondition(condition) {
        const conditionKey = `apartment.condition.${condition}`;
        let conditionTranslation = t(conditionKey);

        return conditionTranslation !== conditionKey ? conditionTranslation : condition;
    }

    function translateWaterFeeBasis(waterFeeBasis) {
        return t(`apartment.waterFeeBasis.${waterFeeBasis}`);
    }

    useEffect(() => {
        const fetchData = async () => {
            if (!userAttributes && (!location.state || !location.state.userAttributes)) {
                setLoading(true)
                await fetchUserData();
            } else if (location.state && location.state.userAttributes) {
                setUserAttributes(location.state.userAttributes);
            }

            if ((!application || !apartment) && (!location.state || !(location.state.application && location.state.apartment))) {
                setLoading(true)
                await fetchAppAndApartmentData();
            } else if (location.state && location.state.application && location.state.apartment) {
                setApplication(location.state.application);
                setApartment(location.state.apartment);
            }
            setLoading(false)
        };

        fetchData();
    }, [location.state, userAttributes, application, apartment]);

    const fetchUserData = async () => {
        //console.log("fetching user data");
        const userData = await getCurrentUserInfo();
        setUserAttributes(userData.attributes);
    };

    const fetchAppAndApartmentData = async () => {
        const data = await ShowingsApi.getForRentapp(applicationCode);
        // console.log("data");
        // console.log(data);

        if (data.application.contract) {
            let updatedClauses = clauses;
            data.application.contract.selectedClauses.forEach((selectedClause) => {
                if (!updatedClauses.some((clause) => clause.text === selectedClause.text)) {
                    updatedClauses.push(selectedClause);
                }
            });
            if (data.application.contract.details.fixedTermPeriod) {
                updatedClauses = updatedClauses.filter(
                    (clause) =>
                        clause.text !== t('contractCreator.terms.tenantTerminationNotice') &&
                        clause.text !== t('contractCreator.terms.landlordTerminationNotice')
                )
            }

            const contractWithLeea = {
                ...data.application.contract,
                leea: true
            };

            setClauses(updatedClauses);
            setContract(contractWithLeea);
        }

        setApplication(data.application);
        setApartment(data.apartment);
    };

    const handleSubmitCustom = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault()
    };

    const handleCheckboxChange = (clause) => {
        setContract((prevContract) => {
            const isSelected = prevContract.selectedClauses.some(
                (selectedClause) => selectedClause.text === clause.text
            );

            if (isSelected) {
                // Deselect clause only if it is selectable
                if (!clause.isUndeselectable) {
                    return {
                        ...prevContract,
                        selectedClauses: prevContract.selectedClauses.filter(
                            (selectedClause) => selectedClause.text !== clause.text
                        ),
                    };
                }
            } else {
                // Select clause
                return {
                    ...prevContract,
                    selectedClauses: [...prevContract.selectedClauses, clause],
                };
            }

            // If the clause is undeselectable, return the previous state
            return prevContract;
        });
    };

    const handleAddCustom = () => {
        if (customClause.trim().length > 0) {
            const newClause = { text: customClause, isUndeselectable: false };
            setClauses(prevClauses => [...prevClauses, newClause]);
            setContract(prevContract => ({
                ...prevContract,
                selectedClauses: [...prevContract.selectedClauses, newClause]
            }));
            setCustomClause('');
        }
    };

    const generatePDFWithValidation = async () => { // make sure the function is async
        const formData = {
            startDate: contract.details.startDate,
            iban: contract.landlord.iban,
            email: contract.landlord.email,
            phoneNumber: contract.landlord.phone,
            name: contract.landlord.name,
            landlordAddress: contract.landlord.address, // added landlord address
            apartmentAddress: contract.apartment.address, // added apartment address
            buildYear: contract.apartment.buildYear,
            buildingType: contract.apartment.buildingType,
            condition: contract.apartment.condition,
            layout: contract.apartment.layout,
            squareMeters: contract.apartment.squareMeters,
            rentPaymentDay: contract.details.rentPaymentDay,
            rentAmount: contract.details.rentAmount,
            // other fields...
            ...contract.tenants.reduce((acc, tenant, index) => ({
                ...acc,
                [`tenantPhoneNumber${index}`]: tenant.phone,
                [`tenantEmail${index}`]: tenant.email,
                [`tenantName${index}`]: tenant.name,
                [`tenantSSN${index}`]: tenant.idNumber,
                [`tenantAddress${index}`]: tenant.address,
            }), {})
        };

        if (contract.details.firstDismissal) {
            formData.firstDismissalDate = contract.details.firstDismissalDate;
        }

        // Conditionally adding availableUntilDate to formData
        if (contract.details.fixedTermPeriod) {
            formData.availableUntilDate = contract.details.availableUntilDate;
        }

        if (contract.additionalLandlords && contract.additionalLandlords.length > 0) {
            contract.additionalLandlords.forEach((landlord, index) => {
                formData[`additionalLandlordName${index}`] = landlord.name;
                formData[`additionalLandlordEmail${index}`] = landlord.email;
            });
        }

        const schema = generateValidationSchema(contract); // generate the schema based on the contract
        const errors = validateForm(formData, schema); // use the generated schema to validate the form data

        setFormErrors(errors);

        // Check if there are any validation errors
        if (Object.keys(errors).length > 0) {
            // There are validation errors, do not navigate to the next step
            // You could show the error messages to the user here
            //console.error(errors);
            return;
        }

        //contract.leea = true

        setLoading(true)
        try {
            const pdfData2: any = await Api.generateContractPDF(contract); // use await here

            const pdfData = pdfData2.pdf;
            const pdfBlob = new Blob([Buffer.from(pdfData, 'base64')], {
                type: 'application/pdf',
            });

            const pdfUrl = URL.createObjectURL(pdfBlob);

            const link = document.createElement('a')
            const fileName = `${t('contractCreator.fileName')}_${contract.apartment.address.replace(/\s+/g, '_')}.pdf`;
            link.href = pdfUrl
            link.download = fileName
            link.click()
            //window.open(pdfUrl, '_blank')
            history.push(`/users/${apartment.userId}/apartments/${apartment.apartmentId}/applications`);
            const message = t('contractCreator.contract.downloadPDFSuccess')
            toast.info(message, { autoClose: 25000 })
        } catch (error) {
            setLoading(false)
            const message = t('contractCreator.contract.downloadPDFFailed')
            toast.info(message, { autoClose: 25000 })
            console.error('Error generating or opening PDF:', error);
        }
    }

    // const generatePDF = async () => { // make sure the function is async
    //     setLoading(true)
    //     try {
    //         const pdfData2: any = await Api.generateContractPDF(contract); // use await here

    //         const pdfData = pdfData2.pdf;
    //         const pdfBlob = new Blob([Buffer.from(pdfData, 'base64')], {
    //             type: 'application/pdf',
    //         });

    //         const pdfUrl = URL.createObjectURL(pdfBlob);

    //         window.open(pdfUrl, '_blank');

    //         history.push(`/users/${apartment.userId}/apartments/${apartment.apartmentId}/applications`, { tab: "showingReserved" });
    //         const message = t('contractCreator.contract.downloadPDFSuccess')
    //         toast.info(message, { autoClose: 25000 })
    //     } catch (error) {
    //         setLoading(false)
    //         const message = t('contractCreator.contract.downloadPDFFailed')
    //         toast.info(message, { autoClose: 25000 })
    //         console.error('Error generating or opening PDF:', error);
    //     }
    // }

    const cancel = () => {
        history.push(`/users/${apartment.userId}/apartments/${apartment.apartmentId}/applications`);
    }

    const sendForSigning = async () => {
        const formData = {
            startDate: contract.details.startDate,
            iban: contract.landlord.iban,
            email: contract.landlord.email,
            phoneNumber: contract.landlord.phone,
            name: contract.landlord.name,
            landlordAddress: contract.landlord.address, // added landlord address
            apartmentAddress: contract.apartment.address, // added apartment address
            buildYear: contract.apartment.buildYear,
            buildingType: contract.apartment.buildingType,
            condition: contract.apartment.condition,
            layout: contract.apartment.layout,
            squareMeters: contract.apartment.squareMeters,
            rentPaymentDay: contract.details.rentPaymentDay,
            rentAmount: contract.details.rentAmount,
            // other fields...
            ...contract.tenants.reduce((acc, tenant, index) => ({
                ...acc,
                [`tenantPhoneNumber${index}`]: tenant.phone,
                [`tenantEmail${index}`]: tenant.email,
                [`tenantName${index}`]: tenant.name,
                [`tenantSSN${index}`]: tenant.idNumber,
                [`tenantAddress${index}`]: tenant.address,
            }), {})
        };

        if (contract.details.firstDismissal) {
            formData.firstDismissalDate = contract.details.firstDismissalDate;
        }

        // Conditionally adding availableUntilDate to formData
        if (contract.details.fixedTermPeriod) {
            formData.availableUntilDate = contract.details.availableUntilDate;
        }

        if (contract.additionalLandlords && contract.additionalLandlords.length > 0) {
            contract.additionalLandlords.forEach((landlord, index) => {
                formData[`additionalLandlordName${index}`] = landlord.name;
                formData[`additionalLandlordEmail${index}`] = landlord.email;
            });
        }

        const schema = generateValidationSchema(contract); // generate the schema based on the contract
        const errors = validateForm(formData, schema); // use the generated schema to validate the form data

        setFormErrors(errors);

        // Check if there are any validation errors
        if (Object.keys(errors).length > 0) {
            // There are validation errors, do not navigate to the next step
            // You could show the error messages to the user here
            //console.error(errors);
            return;
        }

        //contract.leea = true

        setLoading(true)
        try {
            await Api.sendContractForSigning(contract); // use await here
            history.push(`/users/${apartment.userId}/apartments/${apartment.apartmentId}/applications`);
            const message = t('contractCreator.contract.sendForSigningSuccess')
            toast.info(message, { autoClose: 25000 })
        } catch (error) {
            setLoading(false)
            //console.error(error);
            const message = t('contractCreator.contract.sendForSigningFailed')
            toast.info(message, { autoClose: 25000 })
        }
    }
    const [openPay, setOpenPay] = useState(false)

    const validateBeforePurchase = () => {
        // Build the SAME payload you use in generatePDFWithValidation
        const formData: any = {
            startDate: contract.details.startDate,
            iban: contract.landlord.iban,
            email: contract.landlord.email,
            phoneNumber: contract.landlord.phone,
            name: contract.landlord.name,
            landlordAddress: contract.landlord.address,
            apartmentAddress: contract.apartment.address,
            buildYear: contract.apartment.buildYear,
            buildingType: contract.apartment.buildingType,
            condition: contract.apartment.condition,
            layout: contract.apartment.layout,
            squareMeters: contract.apartment.squareMeters,
            rentPaymentDay: contract.details.rentPaymentDay,
            rentAmount: contract.details.rentAmount,
            ...contract.tenants.reduce((acc, tenant, index) => ({
                ...acc,
                [`tenantPhoneNumber${index}`]: tenant.phone,
                [`tenantEmail${index}`]: tenant.email,
                [`tenantName${index}`]: tenant.name,
                [`tenantSSN${index}`]: tenant.idNumber,
                [`tenantAddress${index}`]: tenant.address,
            }), {})
        }

        if (contract.details.firstDismissal) {
            formData.firstDismissalDate = contract.details.firstDismissalDate
        }
        if (contract.details.fixedTermPeriod) {
            formData.availableUntilDate = contract.details.availableUntilDate
        }
        if (contract.additionalLandlords?.length) {
            contract.additionalLandlords.forEach((l, i) => {
                formData[`additionalLandlordName${i}`] = l.name
                formData[`additionalLandlordEmail${i}`] = l.email
            })
        }

        const schema = generateValidationSchema(contract)
        const errors = validateForm(formData, schema)
        setFormErrors(errors)

        return Object.keys(errors).length === 0
    }

    return (
        <form onSubmit={handleSubmitCustom}>
            <Grid container className={classes.noPrint}>
                {' '}
                {currentStep === 1 && (
                    <>
                        {isLoading === true ? (
                            <LoadingContainer />
                        ) : (
                            <Grid container className={classes.formContainer}>
                                <Grid xs={12} className={classes.responsiveWidth}>
                                    <Grid item xs={12}>
                                        <Typography
                                            variant='h4'
                                            className={`${classes.heading}`}
                                        >
                                            {t('contractCreator.contract.apartmentContract')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} style={{ marginBottom: '1.5rem' }}>
                                        <Suggest
                                            content={t('contractCreator.stepper.instructionsStep1')}
                                            //isModal
                                            containerMaxWidth='100%'
                                            contentMaxWidth='100%'
                                            mediumPaddingOnLargeScreens={true}
                                        />
                                    </Grid>
                                    <Grid
                                        container
                                        spacing={4}

                                    //className={classes.containerItem}
                                    >
                                        <Grid item xs={12} sm={6}>
                                            <Typography
                                                variant='body1'
                                                gutterBottom
                                                className={`${classes.formLabel}`}
                                            >
                                                {t('contractCreator.stepper.iban')}:
                                            </Typography>
                                            <TextField
                                                placeholder={t('contractCreator.stepper.placeholders.iban')}
                                                fullWidth
                                                value={contract.landlord.iban || ''}
                                                error={!!formErrors.iban}
                                                helperText={formErrors.iban || ''}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                InputProps={{
                                                    disableUnderline: true,
                                                    style: {
                                                        height: '100%',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        backgroundColor: 'transparent',
                                                        fontFamily: 'CircularRegular',
                                                    },
                                                }}
                                                className={`customTextField ${formErrors.iban ? 'customTextField-error' : ''}`}
                                                onChange={e => {
                                                    const newValue = e.target.value;
                                                    setContract(prevContract => ({
                                                        ...prevContract,
                                                        landlord: {
                                                            ...prevContract.landlord,
                                                            iban: newValue,
                                                        },
                                                    }));
                                                }}
                                            />


                                            {/* <ReduxFormField
                                                value={contract.landlord.iban || ''}
                                                name='iban'
                                                onChange={(e) => {
                                                    const newValue = e.target.value
                                                    setContract((prevContract) => ({
                                                        ...prevContract,
                                                        landlord: {
                                                            ...prevContract.landlord,
                                                            iban: newValue
                                                        }
                                                    }))
                                                }}
                                                normalize={(value) => value.replace(/\s+/g, '')}
                                                component={MyInput}
                                                style={{
                                                    width: '100%',
                                                    height: '58px',
                                                    padding: '20px',
                                                    background: '#E7ECEF'
                                                }}
                                                required
                                                error={!!formErrors.iban}
                                                helperText={<span className={formErrors.iban ? classes.errorText : ''}>{formErrors.iban}</span>}
                                                placeholder={t('contractCreator.stepper.placeholders.iban')}
                                            /> */}


                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Typography
                                                variant='body1'
                                                gutterBottom
                                                className={`${classes.formLabel}`}
                                            >
                                                {t('contractCreator.stepper.rentPaymentDay')}:
                                            </Typography>
                                            <TextField
                                                //label={t('contractCreator.contract.rentPaymentDay')}
                                                fullWidth
                                                value={contract.details.rentPaymentDay || ''}
                                                error={!!formErrors.rentPaymentDay}
                                                helperText={formErrors.rentPaymentDay || ''}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                InputProps={{
                                                    disableUnderline: true,
                                                    style: {
                                                        height: '100%',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        backgroundColor: 'transparent',
                                                        fontFamily: 'CircularRegular',
                                                    },
                                                }}
                                                className={`customTextField ${formErrors.rentPaymentDay ? 'customTextField-error' : ''}`}
                                                onChange={e => {
                                                    const newValue = e.target.value;
                                                    setContract(prevContract => ({
                                                        ...prevContract,
                                                        details: {
                                                            ...prevContract.details,
                                                            rentPaymentDay: newValue
                                                        }
                                                    }));
                                                }}
                                                placeholder={t('contractCreator.stepper.placeholders.rentPaymentDay')}
                                            />
                                            {/* <ReduxFormField
                                                name='rentPaymentDay'
                                                // Assuming your ReduxFormField supports onChange directly
                                                onChange={(e) => {
                                                    const newValue = e.target.value;
                                                    setContract((prevContract) => ({
                                                        ...prevContract,
                                                        details: {
                                                            ...prevContract.details,
                                                            rentPaymentDay: newValue
                                                        }
                                                    }));
                                                }}
                                                // normalize={charsSpace}
                                                component={MyInput}
                                                style={{
                                                    width: '100%',
                                                    height: '58px',
                                                    padding: '20px',
                                                    background: '#E7ECEF'
                                                }}
                                                // validate={[requiredLocation, isInvalidCharacters]}
                                                error={!!formErrors.rentPaymentDay}
                                                helperText={<span className={formErrors.rentPaymentDay ? classes.errorText : ''}>{formErrors.rentPaymentDay}</span>}
                                                required
                                                placeholder={t('contractCreator.stepper.placeholders.rentPaymentDay')}
                                            /> */}
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Typography
                                                variant='body1'
                                                gutterBottom
                                                className={`${classes.formLabel}`}
                                            >
                                                {t('contractCreator.stepper.numberOfKeys')}:
                                            </Typography>
                                            <TextField
                                                error={!!formErrors.numberOfKeys}
                                                helperText={formErrors.numberOfKeys ? (
                                                    <span className={classes.errorText}>{formErrors.numberOfKeys}</span>
                                                ) : ''}
                                                fullWidth
                                                value={contract.details.numberOfKeys || ''}
                                                name='contract.details.numberOfKeys'
                                                onChange={(e) => {
                                                    const newValue = e.target.value
                                                    setContract(prevContract => ({
                                                        ...prevContract,
                                                        details: {
                                                            ...prevContract.details,
                                                            numberOfKeys: newValue
                                                        }
                                                    }))
                                                }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                InputProps={{
                                                    disableUnderline: true,
                                                    style: {
                                                        height: '100%',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        backgroundColor: 'transparent',
                                                        fontFamily: 'CircularRegular',
                                                    },
                                                }}
                                                className={`customTextField ${formErrors.numberOfKeys ? 'customTextField-error' : ''}`}
                                                // style={{
                                                //     width: '100%',
                                                //     height: '58px',
                                                //     padding: '20px',
                                                //     background: '#E7ECEF'
                                                // }}
                                                //required
                                                placeholder={t('contractCreator.stepper.placeholders.numberOfKeys')}
                                            />

                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Typography
                                                variant='body1'
                                                gutterBottom
                                                className={`${classes.formLabel}`}
                                            >
                                                {t('contractCreator.stepper.landlordStreet')}:
                                            </Typography>
                                            <TextField
                                                placeholder={t('contractCreator.stepper.placeholders.address')}
                                                //label={t('contractCreator.contract.address')}
                                                fullWidth
                                                value={contract.landlord.address}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                InputProps={{
                                                    disableUnderline: true,
                                                    style: {
                                                        height: '100%',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        backgroundColor: 'transparent',
                                                        fontFamily: 'CircularRegular',
                                                    },
                                                }}
                                                className={`customTextField ${formErrors.landlordAddress ? 'customTextField-error' : ''}`}
                                                error={!!formErrors.landlordAddress}
                                                helperText={formErrors.landlordAddress || ''}
                                                onChange={e => {
                                                    const newValue = e.target.value;
                                                    setContract(prevContract => ({
                                                        ...prevContract,
                                                        landlord: {
                                                            ...prevContract.landlord,
                                                            address: newValue
                                                        }
                                                    }));
                                                }}
                                            />
                                            {/* <ReduxFormField
                                                error={!!formErrors.landlordStreet}
                                                helperText={<span className={formErrors.landlordStreet ? classes.errorText : ''}>{formErrors.landlordStreet}</span>}
                                                name='contract.landlord.street'
                                                component={MyInput}
                                                style={{
                                                    width: '100%',
                                                    height: '58px',
                                                    padding: '20px',
                                                    background: '#E7ECEF'
                                                }}
                                                required
                                                onChange={(e) => {
                                                    const newValue = e.target.value;
                                                    setContract(prevContract => ({
                                                        ...prevContract,
                                                        landlord: {
                                                            ...prevContract.landlord,
                                                            street: newValue
                                                        }
                                                    }));
                                                }}
                                                placeholder={t('contractCreator.stepper.placeholders.street')}
                                            /> */}

                                        </Grid>
                                        {/* <Grid item xs={12} sm={3}>
                                            <Typography
                                                variant='body1'
                                                gutterBottom
                                                className={`${classes.formLabel}`}
                                            >
                                                {t('contractCreator.stepper.landlordPostalCode')}:
                                            </Typography>
                                            <ReduxFormField
                                                error={!!formErrors.landlordPostalCode}
                                                helperText={<span className={formErrors.landlordPostalCode ? classes.errorText : ''}>{formErrors.landlordPostalCode}</span>}

                                                name='contract.landlord.postalCode'
                                                component={MyInput}
                                                style={{
                                                    width: '100%',
                                                    height: '58px',
                                                    padding: '20px',
                                                    background: '#E7ECEF'
                                                }}
                                                required
                                                onChange={(e) => {
                                                    const newValue = e.target.value;
                                                    setContract(prevContract => ({
                                                        ...prevContract,
                                                        landlord: {
                                                            ...prevContract.landlord,
                                                            postalCode: newValue
                                                        }
                                                    }));
                                                }}
                                                placeholder={t('contractCreator.stepper.placeholders.postalCode')}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                            <Typography
                                                variant='body1'
                                                gutterBottom
                                                className={`${classes.formLabel}`}
                                            >
                                                {t('contractCreator.stepper.landlordCity')}:
                                            </Typography>
                                            <ReduxFormField
                                                error={!!formErrors.landlordCity}
                                                helperText={<span className={formErrors.landlordCity ? classes.errorText : ''}>{formErrors.landlordCity}</span>}

                                                name='contract.landlord.city'
                                                component={MyInput}
                                                style={{
                                                    width: '100%',
                                                    height: '58px',
                                                    padding: '20px',
                                                    background: '#E7ECEF'
                                                }}
                                                required
                                                onChange={(e) => {
                                                    const newValue = e.target.value;
                                                    setContract(prevContract => ({
                                                        ...prevContract,
                                                        landlord: {
                                                            ...prevContract.landlord,
                                                            city: newValue
                                                        }
                                                    }));
                                                }}
                                                placeholder={t('contractCreator.stepper.placeholders.city')}
                                            />
                                        </Grid> */}
                                        <Grid item xs={12} sm={12}>
                                            <RadioGroup
                                                row
                                                value={contract.details.fixedTermPeriod === undefined || contract.details.fixedTermPeriod === null ? '' : contract.details.fixedTermPeriod ? 'true' : 'false'}
                                                onChange={(event) => {
                                                    const isFixedTerm = event.target.value === 'true';
                                                    setContract({
                                                        ...contract,
                                                        details: {
                                                            ...contract.details,
                                                            fixedTermPeriod: isFixedTerm,
                                                            firstDismissal: isFixedTerm ? false : contract.details.firstDismissal
                                                        }
                                                    });
                                                    updateClauses(isFixedTerm);
                                                }}
                                            >
                                                <FormControlLabel
                                                    value="false"
                                                    control={<Radio color="primary" />}
                                                    label={t('contractCreator.stepper.formerlyValid')}
                                                />
                                                <FormControlLabel
                                                    value="true"
                                                    control={<Radio color="primary" />}
                                                    label={t('contractCreator.stepper.fixedTermContract')}
                                                />
                                            </RadioGroup>
                                            {!!formErrors.fixedTermPeriod && (
                                                <Typography variant="caption" color="error">
                                                    {formErrors.fixedTermPeriod}
                                                </Typography>
                                            )}

                                            <Grid item xs={12} sm={12} style={{ marginTop: '10px', marginLeft: '1px' }}>
                                                <ReduxDatePicker
                                                    error={!!formErrors.startDate}
                                                    helperText={formErrors.startDate || ''}
                                                    className={`${classes.formLabel}`}
                                                    meta={{ touched: false, invalid: false, error: '' }}
                                                    label={t('contractCreator.contract.contractStartDate')}
                                                    invalidLabel="Invalid Date"
                                                    clearable
                                                    style={{ width: '16rem' }}
                                                    input={{
                                                        value: contract.details.startDate,
                                                        onChange: (momentValue) => {
                                                            const formattedValue = momentValue && momentValue.format
                                                                ? momentValue.format('YYYY-MM-DD')
                                                                : '';
                                                            setContract(prevContract => ({
                                                                ...prevContract,
                                                                details: {
                                                                    ...prevContract.details,
                                                                    startDate: formattedValue
                                                                }
                                                            }));
                                                        },
                                                        onBlur: () => { }
                                                    }}
                                                />
                                            </Grid>

                                            {contract.details.fixedTermPeriod === true && (
                                                <Grid item xs={12} sm={12} style={{ marginTop: '10px', marginLeft: '1px' }}>
                                                    <ReduxDatePicker
                                                        error={!!formErrors.availableUntilDate}
                                                        helperText={formErrors.availableUntilDate || ''}
                                                        className={`${classes.formLabel}`}
                                                        meta={{ touched: false, invalid: false, error: '' }}
                                                        label={t('contractCreator.stepper.availableUntil')}
                                                        invalidLabel="Invalid Date"
                                                        style={{ width: '16rem' }}
                                                        input={{
                                                            value: contract.details.availableUntilDate,
                                                            onChange: (momentValue) => {
                                                                setContract({
                                                                    ...contract,
                                                                    details: {
                                                                        ...contract.details,
                                                                        availableUntilDate: momentValue.format('YYYY-MM-DD')
                                                                    }
                                                                });
                                                                //updateClauses();
                                                            },
                                                            onBlur: () => { }
                                                        }}
                                                    />
                                                </Grid>
                                            )}

                                            {contract.details.fixedTermPeriod === false && (
                                                <Grid item xs={12} sm={12} style={{ marginTop: '10px', marginLeft: '1px' }}>
                                                    <ReduxDatePicker
                                                        error={!!formErrors.firstDismissalDate}
                                                        helperText={formErrors.firstDismissalDate || ''}
                                                        className={`${classes.formLabel}`}
                                                        meta={{ touched: false, invalid: false, error: '' }}
                                                        label={t('contractCreator.stepper.firstDismissalDate')}
                                                        invalidLabel="Invalid Date"
                                                        clearable
                                                        style={{ width: '16rem' }}
                                                        input={{
                                                            value: contract.details.firstDismissalDate,
                                                            onChange: (momentValue) => {
                                                                if (momentValue) {
                                                                    setContract({
                                                                        ...contract,
                                                                        details: {
                                                                            ...contract.details,
                                                                            firstDismissalDate: momentValue.format('YYYY-MM-DD'),
                                                                            firstDismissal: true
                                                                        }
                                                                    });
                                                                } else {
                                                                    setContract({
                                                                        ...contract,
                                                                        details: {
                                                                            ...contract.details,
                                                                            firstDismissalDate: null,
                                                                            firstDismissal: false
                                                                        }
                                                                    });
                                                                }
                                                                //updateClauses();
                                                                handleFirstDismissal(momentValue);
                                                            },
                                                            onBlur: () => { }
                                                        }}
                                                    />
                                                </Grid>
                                            )}
                                        </Grid>
                                        {contract.additionalLandlords.map((landlord, index) => (
                                            <Grid key={index} style={{ marginTop: 10, marginLeft: 15 }}>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={6}>
                                                        <TextField
                                                            label={t('contractCreator.contract.nameCompany')}
                                                            name={`additionalLandlords[${index}].name`}
                                                            value={landlord.name}
                                                            onChange={(e) => {
                                                                const newValue = e.target.value;
                                                                setContract(prevContract => {
                                                                    const newLandlordArray = [...prevContract.additionalLandlords];
                                                                    newLandlordArray[index].name = newValue;
                                                                    return { ...prevContract, additionalLandlords: newLandlordArray };
                                                                });
                                                            }}
                                                            variant="outlined"
                                                            className={classes.roundedInput}
                                                            error={!!formErrors[`additionalLandlordName${index}`]}
                                                            helperText={formErrors[`additionalLandlordName${index}`]}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <TextField
                                                            label={t('contractCreator.contract.email')}
                                                            name={`additionalLandlords[${index}].email`}
                                                            value={landlord.email}
                                                            onChange={(e) => {
                                                                const newValue = e.target.value;
                                                                setContract(prevContract => {
                                                                    const newLandlordArray = [...prevContract.additionalLandlords];
                                                                    newLandlordArray[index].email = newValue;
                                                                    return { ...prevContract, additionalLandlords: newLandlordArray };
                                                                });
                                                            }}
                                                            variant="outlined"
                                                            className={classes.roundedInput}
                                                            error={!!formErrors[`additionalLandlordEmail${index}`]}
                                                            helperText={formErrors[`additionalLandlordEmail${index}`]}
                                                        />
                                                    </Grid>
                                                </Grid>
                                                <Button
                                                    onClick={() => {
                                                        setContract(prevContract => {
                                                            const newLandlordArray = prevContract.additionalLandlords.filter((_, i) => i !== index);
                                                            return { ...prevContract, additionalLandlords: newLandlordArray };
                                                        });
                                                    }}
                                                >
                                                    {t('contractCreator.stepper.remove')}
                                                </Button>
                                            </Grid>
                                        ))}

                                        <Grid item xs={12} sm={12}>
                                            <Button
                                                variant='outlined'
                                                className={`${classes.responsiveButton} ${classes.addAnotherLandlordButton}`}
                                                onClick={addOtherLandlord}
                                            >
                                                <Box display="flex" alignItems="center" flexWrap="nowrap"> {/* Here's where the change is */}
                                                    <Box style={{ marginTop: '6px', marginRight: '5px' }}>
                                                        <img src={PlusIcon} />
                                                    </Box>
                                                    <Box ml={1} fontWeight="bold">
                                                        {t('contractCreator.stepper.addAnotherLandlord')}
                                                    </Box>
                                                </Box>
                                            </Button>
                                        </Grid>

                                    </Grid>
                                    <Grid item xs={12} sm={12} container style={{ marginTop: '1.5rem', marginBottom: '0.5rem' }}>
                                        <Grid item xs={12} sm={6}>
                                            <Grid item>
                                                <Button
                                                    // disabled={isChecked}
                                                    fullWidth
                                                    variant='outlined'
                                                    //color='primary'
                                                    className={`${classes.responsiveButton} ${classes.bottomButton1} ${classes.bottomButton}`}
                                                    onClick={() => cancel()}
                                                >
                                                    <Grid
                                                        container
                                                        justify='center'
                                                        alignItems='center'
                                                    >
                                                        <Grid item>{t('contractCreator.stepper.cancel')}</Grid>
                                                        <Grid item className={`${classes.leftFloatingIcon} ${classes.arrowIcon}`}>
                                                            <ChevronLeftIcon color='#94004A' />
                                                        </Grid>
                                                    </Grid>
                                                </Button>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Grid item>
                                                <Button
                                                    // disabled={isChecked}
                                                    fullWidth
                                                    variant='contained'
                                                    color='primary'
                                                    className={`${classes.responsiveButton} ${classes.bottomButton2} ${classes.bottomButton}`}
                                                    onClick={() => navigateStep1To2()}
                                                >
                                                    <Grid
                                                        container
                                                        justify='center'
                                                        alignItems='center'
                                                    >
                                                        <Grid item>{t('contractCreator.stepper.next')}</Grid>
                                                        <Grid item className={`${classes.rightFloatingIcon} ${classes.arrowIcon}`}>
                                                            <ChevronRightIcon color='#D8DCDF' />
                                                        </Grid>
                                                    </Grid>
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        )}
                    </>
                )}
                {currentStep === 2 && (
                    <>
                        {isLoading === true ? (
                            <LoadingContainer />
                        ) : (
                            <Grid container className={classes.formContainer}>
                                <Grid xs={12} className={classes.responsiveWidth}>
                                    <Grid item xs={12}>
                                        <Typography
                                            variant='h4'
                                            className={`${classes.heading}`}
                                        >
                                            {t('contractCreator.stepper.selectedClauses')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} style={{ marginBottom: '0.5rem' }}>
                                        <Suggest
                                            content={t('contractCreator.stepper.instructionsStep2')}
                                            //isModal
                                            containerMaxWidth='100%'
                                            contentMaxWidth='100%'
                                            mediumPaddingOnLargeScreens={true}
                                        />
                                    </Grid>
                                    <Grid container xs={12} className={`${classes.clauseContainer}`}>
                                        {clauses
                                            .sort((a, b) => {
                                                if (a.isUndeselectable && !b.isUndeselectable) {
                                                    return -1;
                                                }
                                                if (!a.isUndeselectable && b.isUndeselectable) {
                                                    return 1;
                                                }
                                                return 0;
                                            })
                                            .map((clause, index) => (
                                                <Grid item xs={12} key={index} style={{ width: '100%', marginBottom: '13px' }}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={contract.selectedClauses.some(selectedClause => selectedClause.text === clause.text)}
                                                                onChange={() => handleCheckboxChange(clause)}
                                                                color="primary"
                                                                className={clause.isUndeselectable ? classes.disabledCheckbox : ''}
                                                            />
                                                        }
                                                        label={
                                                            <Typography variant="body1">
                                                                {clause.text}
                                                                {clause.isUndeselectable && (
                                                                    <span style={{ marginLeft: '8px', color: '#94004A' }}>
                                                                        {t('contractCreator.stepper.required')}
                                                                    </span>
                                                                )}
                                                            </Typography>
                                                        }
                                                        className={classes.clauses}
                                                    />
                                                </Grid>
                                            ))}
                                        <Grid item xs={12}>
                                            <TextField
                                                label={t('contractCreator.stepper.addCustomClauseLabel')}
                                                fullWidth
                                                value={customClause}
                                                onChange={e => setCustomClause(e.target.value)}
                                            />
                                            <Button style={{ marginBottom: 20, marginTop: 5 }} variant="contained" color="primary" onClick={handleAddCustom}>
                                                {t('contractCreator.stepper.addCustomClause')}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} sm={12} container style={{ marginTop: '2rem', marginBottom: '0.5rem' }}>
                                        <Grid item xs={12} sm={6}>
                                            <Grid item>
                                                <Button
                                                    // disabled={isChecked}
                                                    fullWidth
                                                    variant='outlined'
                                                    //color='primary'
                                                    className={`${classes.responsiveButton} ${classes.bottomButton1} ${classes.bottomButton}`}
                                                    onClick={() => navigateTo(1)}
                                                >
                                                    <Grid
                                                        container
                                                        justify='center'
                                                        alignItems='center'
                                                    >
                                                        <Grid item>{t('contractCreator.stepper.cancel')}</Grid>
                                                        <Grid item className={`${classes.leftFloatingIcon} ${classes.arrowIcon}`}>
                                                            <ChevronLeftIcon color='#94004A' />
                                                        </Grid>
                                                    </Grid>
                                                </Button>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Grid item>
                                                <Button
                                                    // disabled={isChecked}
                                                    fullWidth
                                                    variant='contained'
                                                    color='primary'
                                                    className={`${classes.responsiveButton} ${classes.bottomButton2} ${classes.bottomButton}`}
                                                    onClick={() => navigateTo(3)}
                                                >
                                                    <Grid
                                                        container
                                                        justify='center'
                                                        alignItems='center'
                                                    >
                                                        <Grid item>{t('contractCreator.stepper.next')}</Grid>
                                                        <Grid item className={`${classes.rightFloatingIcon} ${classes.arrowIcon}`}>
                                                            <ChevronRightIcon color='#D8DCDF' />
                                                        </Grid>
                                                    </Grid>
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        )}
                    </>
                )}
                {currentStep === 3 && (
                    isLoading ? (
                        <LoadingContainer />
                    ) : (
                        <ContractGeneratorDigivakuusStep
                            t={t}
                            classes={classes}
                            digivakuusDepositAccepted={digivakuusDepositAccepted}
                            setDigivakuusDepositAccepted={setDigivakuusDepositAccepted}
                            digivakuusEscrowServiceAccepted={digivakuusEscrowServiceAccepted}
                            setDigivakuusEscrowServiceAccepted={setDigivakuusEscrowServiceAccepted}
                            ropoRentChargingServiceAccepted={ropoRentChargingServiceAccepted}
                            setRopoRentChargingServiceAccepted={setRopoRentChargingServiceAccepted}
                            navigateTo={navigateTo}
                            ChevronLeftIcon={ChevronLeftIcon}
                            ChevronRightIcon={ChevronRightIcon}
                            showExistingProducts={showExistingDigivakuusProducts}
                            applicantIsDigivakuusVerified={applicantIsDigivakuusVerified}
                        />

                    )
                )}
                {currentStep === 4 && (
                    <>
                        {isLoading === true ? (
                            <LoadingContainer />
                        ) : (
                            <Grid container className={classes.formContainer}>
                                <Grid xs={12} className={classes.responsiveWidth}>
                                    {/* <Grid item xs={12}>
                                            <Typography variant="h4" style={{ textTransform: 'uppercase' }}>{t('contractCreator.contract.contractPreview'')}</Typography>
                                        </Grid> */}
                                    <Grid item xs={12}>
                                        <Typography
                                            variant='h4'
                                            className={`${classes.heading}`}
                                        >
                                            {t('contractCreator.contract.contractPreview')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} style={{ marginBottom: '0.5rem' }}>
                                        <Suggest
                                            content={t('contractCreator.stepper.instructionsStep3')}
                                            //isModal
                                            containerMaxWidth='100%'
                                            contentMaxWidth='100%'
                                            mediumPaddingOnLargeScreens={true}

                                        />
                                    </Grid>
                                    <Grid container spacing={3} className={`${classes.contractFormContainer}`} style={{ margin: '0px', width: '100%' }}>
                                        <Grid item xs={12}>
                                            <Typography variant="h5" className={`${classes.subHeadingAfterDisclaimer}`} style={{ marginTop: '0.6rem' }}>1. {t('contractCreator.contract.landlord')}</Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label={t('contractCreator.contract.nameCompany')}
                                                fullWidth
                                                value={contract.landlord.name}
                                                error={!!formErrors.name}
                                                helperText={formErrors.name || ''}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                onChange={e => {
                                                    const newValue = e.target.value;
                                                    setContract(prevContract => ({
                                                        ...prevContract,
                                                        landlord: {
                                                            ...prevContract.landlord,
                                                            name: newValue
                                                        }
                                                    }));
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label={t('contractCreator.contract.phoneNumber')}
                                                fullWidth
                                                value={contract.landlord.phone}
                                                error={!!formErrors.phoneNumber}
                                                helperText={formErrors.phoneNumber || ''}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                onChange={e => {
                                                    const newValue = e.target.value;
                                                    setContract(prevContract => ({
                                                        ...prevContract,
                                                        landlord: {
                                                            ...prevContract.landlord,
                                                            phone: newValue
                                                        }
                                                    }));
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label={t('contractCreator.contract.address')}
                                                fullWidth
                                                value={contract.landlord.address}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                error={!!formErrors.landlordAddress}
                                                helperText={formErrors.landlordAddress || ''}
                                                onChange={e => {
                                                    const newValue = e.target.value;
                                                    setContract(prevContract => ({
                                                        ...prevContract,
                                                        landlord: {
                                                            ...prevContract.landlord,
                                                            address: newValue
                                                        }
                                                    }));
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label={t('contractCreator.contract.email')}
                                                fullWidth
                                                value={contract.landlord.email}
                                                error={!!formErrors.email}
                                                helperText={formErrors.email || ''}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                onChange={e => {
                                                    const newValue = e.target.value;
                                                    setContract(prevContract => ({
                                                        ...prevContract,
                                                        landlord: {
                                                            ...prevContract.landlord,
                                                            email: newValue
                                                        }
                                                    }));
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label={t('contractCreator.stepper.iban')}
                                                fullWidth
                                                value={contract.landlord.iban || ''}
                                                error={!!formErrors.iban}
                                                helperText={formErrors.iban || ''}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                onChange={e => {
                                                    const newValue = e.target.value;
                                                    setContract(prevContract => ({
                                                        ...prevContract,
                                                        landlord: {
                                                            ...prevContract.landlord,
                                                            iban: newValue
                                                        }
                                                    }));
                                                }}
                                            />
                                        </Grid>

                                        {contract.additionalLandlords && contract.additionalLandlords.length > 0 && (
                                            <>
                                                <Grid item xs={12}>
                                                    <Typography variant="h6">{t('contractCreator.contract.additionalLandlords')}</Typography>
                                                </Grid>
                                                {contract.additionalLandlords.map((landlord, index) => (
                                                    <Fragment key={index}>
                                                        <Grid item xs={12} sm={6}>
                                                            <TextField
                                                                error={!!formErrors[`additionalLandlordName${index}`]}
                                                                helperText={formErrors[`additionalLandlordName${index}`] || ''}
                                                                label={t('contractCreator.contract.nameCompany')}
                                                                fullWidth
                                                                value={landlord.name}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                                onChange={(e) => {
                                                                    const newValue = e.target.value;
                                                                    setContract((prevContract) => {
                                                                        const updatedLandlords = [...prevContract.additionalLandlords];
                                                                        updatedLandlords[index] = {
                                                                            ...updatedLandlords[index],
                                                                            name: newValue,
                                                                        };
                                                                        return {
                                                                            ...prevContract,
                                                                            additionalLandlords: updatedLandlords,
                                                                        };
                                                                    });
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} sm={6}>
                                                            <TextField
                                                                error={!!formErrors[`additionalLandlordEmail${index}`]}
                                                                helperText={formErrors[`additionalLandlordEmail${index}`] || ''}
                                                                label={t('contractCreator.contract.email')}
                                                                fullWidth
                                                                value={landlord.email}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                                onChange={(e) => {
                                                                    const newValue = e.target.value;
                                                                    setContract((prevContract) => {
                                                                        const updatedLandlords = [...prevContract.additionalLandlords];
                                                                        updatedLandlords[index] = {
                                                                            ...updatedLandlords[index],
                                                                            email: newValue,
                                                                        };
                                                                        return {
                                                                            ...prevContract,
                                                                            additionalLandlords: updatedLandlords,
                                                                        };
                                                                    });
                                                                }}
                                                            />
                                                        </Grid>
                                                    </Fragment>
                                                ))}
                                            </>
                                        )}
                                        {/* <Grid item xs={12} style={{ textAlign: 'center' }}>
                                            <Typography variant="body2">
                                                {t('contractCreator.contract.rightToRent')}.
                                            </Typography>
                                        </Grid> */}

                                        {contract.tenants.map((tenant, index) => (
                                            <Fragment key={index}>
                                                <Fragment>
                                                    <Grid item xs={12}>
                                                        <Typography variant="h5" className={`${classes.subHeadingAfterDisclaimer}`}>
                                                            {`2. ${t('contractCreator.contract.mainTenant')}${contract.tenants.length > 1 ? ` ${index + 1}` : ''}`}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <TextField
                                                            label={t('contractCreator.contract.nameCompany')}
                                                            fullWidth
                                                            value={tenant.name}
                                                            error={!!formErrors[`tenantName${index}`]}
                                                            helperText={formErrors[`tenantName${index}`] || ''}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            onChange={e => {
                                                                const newValue = e.target.value;
                                                                setContract(prevContract => {
                                                                    const updatedTenants = prevContract.tenants.map((t, i) =>
                                                                        i === index ? { ...t, name: newValue } : t
                                                                    );
                                                                    return { ...prevContract, tenants: updatedTenants };
                                                                });
                                                            }}
                                                        />
                                                    </Grid>

                                                    {/* Similar onChange handlers for the other fields... */}
                                                    <Grid item xs={12} sm={6}>
                                                        <TextField
                                                            label={t('contractCreator.contract.socialSecurityNumber')}
                                                            fullWidth
                                                            value={tenant.idNumber}
                                                            error={!!formErrors[`tenantSSN${index}`]}
                                                            helperText={formErrors[`tenantSSN${index}`] || ''}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            onChange={e => {
                                                                const newValue = e.target.value;
                                                                setContract(prevContract => {
                                                                    const updatedTenants = prevContract.tenants.map((t, i) =>
                                                                        i === index ? { ...t, idNumber: newValue } : t
                                                                    );
                                                                    return { ...prevContract, tenants: updatedTenants };
                                                                });
                                                            }}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} sm={6}>
                                                        <TextField
                                                            label={t('contractCreator.contract.address')}
                                                            fullWidth
                                                            value={tenant.address}
                                                            error={!!formErrors[`tenantAddress${index}`]}
                                                            helperText={formErrors[`tenantAddress${index}`] || ''}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            onChange={e => {
                                                                const newValue = e.target.value;
                                                                setContract(prevContract => {
                                                                    const updatedTenants = prevContract.tenants.map((t, i) =>
                                                                        i === index ? { ...t, address: newValue } : t
                                                                    );
                                                                    return { ...prevContract, tenants: updatedTenants };
                                                                });
                                                            }}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} sm={6}>
                                                        <TextField
                                                            label={t('contractCreator.contract.phoneNumber')}
                                                            fullWidth
                                                            value={tenant.phone}
                                                            error={!!formErrors[`tenantPhoneNumber${index}`]}
                                                            helperText={formErrors[`tenantPhoneNumber${index}`] || ''}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            onChange={e => {
                                                                const newValue = e.target.value;
                                                                setContract(prevContract => {
                                                                    const updatedTenants = prevContract.tenants.map((t, i) =>
                                                                        i === index ? { ...t, phone: newValue } : t
                                                                    );
                                                                    return { ...prevContract, tenants: updatedTenants };
                                                                });
                                                            }}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} sm={6}>
                                                        <TextField
                                                            label={t('contractCreator.contract.email')}
                                                            error={!!formErrors[`tenantEmail${index}`]}
                                                            helperText={formErrors[`tenantEmail${index}`] || ''}
                                                            fullWidth
                                                            value={tenant.email}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            onChange={e => {
                                                                const newValue = e.target.value;
                                                                setContract(prevContract => {
                                                                    const updatedTenants = prevContract.tenants.map((t, i) =>
                                                                        i === index ? { ...t, email: newValue } : t
                                                                    );
                                                                    return { ...prevContract, tenants: updatedTenants };
                                                                });
                                                            }}
                                                        />
                                                    </Grid>
                                                </Fragment>
                                                {/* <Grid item xs={12} style={{ textAlign: 'center' }}>
                                                    <Typography variant="body2">
                                                        {t('contractCreator.contract.identityChecked')}. {t('contractCreator.contract.creditScoreChecked')}.
                                                    </Typography>
                                                </Grid> */}
                                            </Fragment>
                                        ))}

                                        <Grid item xs={12}>
                                            <Typography variant="h5" className={`${classes.subHeadingAfterDisclaimer}`}>3. {t('contractCreator.contract.targetApartment')}</Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label={t('contractCreator.contract.address')}
                                                fullWidth
                                                value={contract.apartment.address}
                                                error={!!formErrors.apartmentAddress}
                                                helperText={formErrors.apartmentAddress || ''}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                //style={{ backgroundColor: 'yellow' }}
                                                onChange={e => {
                                                    const newValue = e.target.value;
                                                    setContract(prevContract => ({
                                                        ...prevContract,
                                                        apartment: {
                                                            ...prevContract.apartment,
                                                            address: newValue
                                                        }
                                                    }));
                                                }}
                                            />
                                            {!/^\S+\s+\S+.*,\s*\d{5}/.test(contract.apartment.address) &&
                                                contract.apartment.address && (
                                                    <Typography style={{ color: '#94004A', marginTop: '4px', fontSize: '0.85rem' }}>
                                                        {t('contractCreator.validation.checkApartmentAddress')}
                                                    </Typography>
                                                )}
                                            <Typography
                                                style={{
                                                    backgroundColor: '#fff4cc',
                                                    border: '1px solid #ffcc66',
                                                    padding: '10px 12px',
                                                    marginTop: '8px',
                                                    fontSize: '0.85rem',
                                                    borderRadius: '8px',
                                                    //color: '#8a6d3b'
                                                }}
                                            >
                                                {t('contractCreator.disclaimer.apartmentAddress')}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label={t('contractCreator.contract.propertyType')}
                                                fullWidth
                                                value={contract.apartment.buildingType}
                                                error={!!formErrors.buildingType}
                                                helperText={formErrors.buildingType || ''}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                onChange={e => {
                                                    const newValue = e.target.value;
                                                    setContract(prevContract => ({
                                                        ...prevContract,
                                                        apartment: {
                                                            ...prevContract.apartment,
                                                            buildingType: newValue
                                                        }
                                                    }));
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label={t('contractCreator.contract.numberOfRooms')}
                                                fullWidth
                                                value={contract.apartment.layout}
                                                error={!!formErrors.layout}
                                                helperText={formErrors.layout || ''}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                onChange={e => {
                                                    const newValue = e.target.value;
                                                    setContract(prevContract => ({
                                                        ...prevContract,
                                                        apartment: {
                                                            ...prevContract.apartment,
                                                            layout: newValue
                                                        }
                                                    }));
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label={t('contractCreator.contract.apartmentArea')}
                                                fullWidth
                                                value={contract.apartment.squareMeters}
                                                error={!!formErrors.squareMeters}
                                                helperText={formErrors.squareMeters || ''}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                onChange={e => {
                                                    const newValue = e.target.value;
                                                    setContract(prevContract => ({
                                                        ...prevContract,
                                                        apartment: {
                                                            ...prevContract.apartment,
                                                            squareMeters: newValue
                                                        }
                                                    }));
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label={t('contractCreator.contract.yearBuilt')}
                                                fullWidth
                                                value={contract.apartment.buildYear}
                                                error={!!formErrors.buildYear}
                                                helperText={formErrors.buildYear || ''}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                onChange={e => {
                                                    const newValue = e.target.value;
                                                    setContract(prevContract => ({
                                                        ...prevContract,
                                                        apartment: {
                                                            ...prevContract.apartment,
                                                            buildYear: newValue
                                                        }
                                                    }));
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label={t('contractCreator.contract.condition')}
                                                fullWidth
                                                value={contract.apartment.condition}
                                                error={!!formErrors.condition}
                                                helperText={formErrors.condition || ''}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                onChange={e => {
                                                    const newValue = e.target.value;
                                                    setContract(prevContract => ({
                                                        ...prevContract,
                                                        apartment: {
                                                            ...prevContract.apartment,
                                                            condition: newValue
                                                        }
                                                    }));
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label={t('contractCreator.contract.additionalSpaces')}
                                                fullWidth
                                                value={contract.apartment.additionalSpaces}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                onChange={e => {
                                                    const newValue = e.target.value;
                                                    setContract(prevContract => ({
                                                        ...prevContract,
                                                        apartment: {
                                                            ...prevContract.apartment,
                                                            additionalSpaces: newValue
                                                        }
                                                    }));
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label={t('contractCreator.contract.commonSpaces')}
                                                fullWidth
                                                value={contract.apartment.commonSpaces}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                onChange={e => {
                                                    const newValue = e.target.value;
                                                    setContract(prevContract => ({
                                                        ...prevContract,
                                                        apartment: {
                                                            ...prevContract.apartment,
                                                            commonSpaces: newValue
                                                        }
                                                    }));
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Typography variant="h5" className={`${classes.subHeading}`}>4. {t('contractCreator.contract.rentAndOtherFees')}</Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                error={!!formErrors.rentAmount}
                                                helperText={formErrors.rentAmount || ''}
                                                label={t('contractCreator.contract.rentAmount')}
                                                fullWidth
                                                value={contract.details.rentAmount || ''}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                onChange={e => {
                                                    const newValue = e.target.value;
                                                    setContract(prevContract => ({
                                                        ...prevContract,
                                                        details: {
                                                            ...prevContract.details,
                                                            rentAmount: newValue
                                                        }
                                                    }));
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label={t('contractCreator.contract.rentPaymentDay')}
                                                fullWidth
                                                value={contract.details.rentPaymentDay || ''}
                                                error={!!formErrors.rentPaymentDay}
                                                helperText={formErrors.rentPaymentDay || ''}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                onChange={e => {
                                                    const newValue = e.target.value;
                                                    setContract(prevContract => ({
                                                        ...prevContract,
                                                        details: {
                                                            ...prevContract.details,
                                                            rentPaymentDay: newValue
                                                        }
                                                    }));
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label={t('contractCreator.contract.waterFee')}
                                                fullWidth
                                                value={contract.details.waterFee}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                onChange={e => {
                                                    const newValue = e.target.value;
                                                    setContract(prevContract => ({
                                                        ...prevContract,
                                                        details: {
                                                            ...prevContract.details,
                                                            waterFee: newValue
                                                        }
                                                    }));
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label={t('contractCreator.contract.otherCosts')}
                                                fullWidth
                                                value={contract.details.otherCosts}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                onChange={e => {
                                                    const newValue = e.target.value;
                                                    setContract(prevContract => ({
                                                        ...prevContract,
                                                        details: {
                                                            ...prevContract.details,
                                                            otherCosts: newValue
                                                        }
                                                    }));
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Typography variant="h5" className={`${classes.subHeading}`}>5. {t('contractCreator.contract.rentPeriod')}</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label={t('contractCreator.contract.contractType')} // No label as per your requirement
                                                value={contract.details.fixedTermPeriod ? t('contractCreator.contract.fixedTermPeriod') : t('contractCreator.contract.openEnded')}
                                                InputProps={{
                                                    readOnly: true, // Assuming you don't want the user to edit this field
                                                }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <ReduxDatePicker
                                                meta={{ touched: false, invalid: false, error: '' }}
                                                label={t('contractCreator.contract.startDate')}
                                                invalidLabel="Invalid Date"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                input={{
                                                    value: contract.details.startDate,
                                                    onChange: (momentValue) => {
                                                        setContract({
                                                            ...contract,
                                                            details: {
                                                                ...contract.details,
                                                                startDate: momentValue.format('YYYY-MM-DD')
                                                            }
                                                        });
                                                    },
                                                    onBlur: () => { }
                                                }}
                                                style={{ width: '100%' }}
                                            />
                                        </Grid>
                                        {/* <Grid item xs={6}>
                                            <TextField label="Vuokrauksen päättymispäivä" fullWidth />
                                        </Grid> */}
                                        {contract.details.fixedTermPeriod ? (
                                            <Grid item xs={12} sm={6}>
                                                <ReduxDatePicker
                                                    meta={{ touched: false, invalid: false, error: '' }}
                                                    label={t('contractCreator.stepper.availableUntil')}
                                                    invalidLabel="Invalid Date"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    error={!!formErrors.availableUntilDate}
                                                    helperText={formErrors.availableUntilDate || ''}
                                                    input={{
                                                        value: contract.details.availableUntilDate,
                                                        onChange: (momentValue) => {
                                                            setContract({
                                                                ...contract,
                                                                details: {
                                                                    ...contract.details,
                                                                    availableUntilDate: momentValue.format('YYYY-MM-DD')
                                                                }
                                                            });
                                                        },
                                                        onBlur: () => { }
                                                    }}
                                                    style={{ width: '100%' }}
                                                />
                                            </Grid>
                                        ) : (
                                            <Grid item xs={12} sm={6}>
                                                <ReduxDatePicker
                                                    meta={{ touched: false, invalid: false, error: '' }}
                                                    label={t('contractCreator.stepper.firstDismissal')}
                                                    invalidLabel="Invalid Date"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    error={!!formErrors.firstDismissalDate}
                                                    helperText={formErrors.firstDismissalDate || ''}
                                                    input={{
                                                        value: contract.details.firstDismissalDate,
                                                        onChange: (momentValue) => {
                                                            setContract({
                                                                ...contract,
                                                                details: {
                                                                    ...contract.details,
                                                                    firstDismissalDate: momentValue.format('YYYY-MM-DD')
                                                                }
                                                            });
                                                        },
                                                        onBlur: () => { }
                                                    }}
                                                    style={{ width: '100%' }}
                                                />
                                            </Grid>
                                        )}
                                        <Grid item xs={12}>
                                            <Typography variant="h5" className={`${classes.subHeading}`}>6. {t('contractCreator.contract.securityDeposit')}</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Typography>
                                                {t('contractCreator.contract.securityDepositInfo')}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label={t('contractCreator.contract.securityDepositAmount')}
                                                fullWidth
                                                value={contract.details.securityDepositAmount}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                onChange={e => {
                                                    const newValue = e.target.value;
                                                    setContract(prevContract => ({
                                                        ...prevContract,
                                                        details: {
                                                            ...prevContract.details,
                                                            securityDepositAmount: newValue
                                                        }
                                                    }));
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Typography>
                                                {t('contractCreator.contract.securityDepositDeadline')}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <ReduxDatePicker
                                                meta={{ touched: false, invalid: false, error: '' }}
                                                label={t('contractCreator.contract.depositLatestDate')}
                                                invalidLabel="Invalid Date"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                input={{
                                                    value: contract.details.depositLatestDate || contract.details.startDate,
                                                    onChange: (momentValue) => {
                                                        setContract({
                                                            ...contract,
                                                            details: {
                                                                ...contract.details,
                                                                depositLatestDate: momentValue.format('YYYY-MM-DD')
                                                            }
                                                        });
                                                    },
                                                    onBlur: () => { }
                                                }}
                                                style={{ width: '100%' }}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography variant="h5" className={`${classes.subHeading}`}>7. {t('contractCreator.contract.clauses')}</Typography>
                                        </Grid>
                                        {[...contract.selectedClauses]
                                            .sort((a, b) =>
                                                clauses.findIndex(clause => clause.text === a.text) -
                                                clauses.findIndex(clause => clause.text === b.text)
                                            )
                                            .map((clause, index) => (
                                                <Grid item xs={12} key={index}>
                                                    <Typography variant="body1">
                                                        {index < 26
                                                            ? String.fromCharCode(65 + index)  // A, B, C, ..., Z
                                                            : (index - 26 + 1) + ''           // 1, 2, 3, ...
                                                        }. {clause.text}
                                                    </Typography>
                                                </Grid>
                                            ))}
                                    </Grid>
                                    {Object.keys(formErrors).length > 0 &&
                                        <Grid item xs={12} sm={12} container style={{ marginTop: '1.5rem', marginBottom: '-0.7rem' }}>
                                            <Box display="flex" justifyContent="center" alignItems="center" style={{ width: '100%', height: '100%' }}>
                                                <Typography variant="h6" style={{ color: '#f44336' }}>
                                                    {t('contractCreator.contract.validationErrors')}
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    }
                                    <Grid item xs={12} sm={12} container style={{ marginTop: '2.2rem', marginBottom: '0.5rem' }}>
                                        <Grid item xs={12} md={6} className={classes.firstOnLarge}>
                                            <Grid item>
                                                <Button
                                                    // disabled={isChecked}
                                                    fullWidth
                                                    variant='outlined'
                                                    //color='primary'
                                                    className={`${classes.responsiveButton} ${classes.bottomButton1ContractPart} ${classes.bottomButton}`}
                                                    onClick={() => navigateTo(3)}
                                                >
                                                    <Grid
                                                        container
                                                        justify='center'
                                                        alignItems='center'
                                                    >
                                                        <Grid item>{t('contractCreator.stepper.cancel')}</Grid>
                                                        <Grid item className={`${classes.leftFloatingIcon} ${classes.arrowIcon}`}>
                                                            <ChevronLeftIcon color='#94004A' />
                                                        </Grid>
                                                    </Grid>
                                                </Button>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} md={6} className={classes.secondOnLarge}>
                                            {apartment && (
                                                <Grid item>
                                                    <Button
                                                        fullWidth
                                                        variant='contained'
                                                        color='primary'
                                                        className={`${classes.responsiveButton} ${classes.bottomButton2ContractPart} ${classes.bottomButton}`}
                                                        onClick={onSendForSigningClick}
                                                    >
                                                        <Grid container justify='center' alignItems='center'>
                                                            <Grid item style={{ marginRight: '13px', marginTop: '6px' }}>
                                                                <img src={SignatureIcon} />
                                                            </Grid>
                                                            <Grid item>{t('contractCreator.stepper.sendForSigning')}</Grid>
                                                        </Grid>
                                                    </Button>

                                                    {/* Opens only when validation passed and user lacks right 6 */}
                                                    <MuiDialog fullScreen={fullScreen} open={openPay} onClose={() => setOpenPay(false)} maxWidth='md' fullWidth>

                                                        <DialogTitle style={{ padding: '8px 16px' }}>
                                                            <IconButton
                                                                aria-label="close"
                                                                onClick={() => setOpenPay(false)}
                                                                className={classes.dialogCloseButton}
                                                            >
                                                                <CloseIcon fontSize="inherit" />
                                                            </IconButton>
                                                        </DialogTitle>

                                                        <MuiDialogContent>
                                                            <PaymentPopup
                                                                productTags={productTags.length ? productTags : ['enableOnlineSigning']}
                                                                headertext={
                                                                    productTags.length > 1
                                                                        ? t('paymentPopup.headerTexts.enableOnlineSigningAndGenerateContract')
                                                                        : productTags[0] === 'generateContract'
                                                                            ? t('paymentPopup.headerTexts.generateContract')
                                                                            : t('paymentPopup.headerTexts.enableOnlineSigning')
                                                                }
                                                                infotext={
                                                                    productTags.length > 1
                                                                        ? t('paymentPopup.suggestTexts.enableOnlineSigningAndGenerateContract')
                                                                        : productTags[0] === 'generateContract'
                                                                            ? <span dangerouslySetInnerHTML={{
                                                                                __html: `${t('paymentPopup.suggestTexts.generateContract')} <a href="https://vuokraovi.leea.fi/generateContract" target="_blank">${t('paymentPopup.contract.downloadText')}</a>`
                                                                            }} />
                                                                            : t('paymentPopup.suggestTexts.enableOnlineSigning')
                                                                }
                                                                apartment={apartment}
                                                                application={application}
                                                                contract={contract}
                                                            />
                                                        </MuiDialogContent>
                                                    </MuiDialog>
                                                </Grid>
                                            )}
                                        </Grid>


                                        <Grid item xs={12} className={classes.thirdOnLarge}>
                                            <Grid item>
                                                <Button
                                                    fullWidth
                                                    variant='outlined'
                                                    className={`${classes.responsiveButton} ${classes.bottomButton}`}
                                                    onClick={onGenerateClick}
                                                >
                                                    <Grid container justify='center' alignItems='center'>
                                                        <Grid item style={{ marginRight: '13px', marginTop: '6px' }}>
                                                            <img src={DownloadIcon} />
                                                        </Grid>
                                                        <Grid item>{t('contractCreator.stepper.generatePdf')}</Grid>
                                                    </Grid>
                                                </Button>

                                                {/* Opens only if user lacks generateContract right AND validation passed */}
                                                <MuiDialog fullScreen={fullScreen} open={openBuyGenerate} onClose={() => setOpenBuyGenerate(false)} maxWidth="md" fullWidth>

                                                    <DialogTitle style={{ padding: '8px 16px' }}>
                                                        <IconButton
                                                            aria-label="close"
                                                            onClick={() => setOpenBuyGenerate(false)}
                                                            className={classes.dialogCloseButton}
                                                        >
                                                            <CloseIcon fontSize="inherit" />
                                                        </IconButton>
                                                    </DialogTitle>
                                                    <MuiDialogContent>
                                                        <PaymentPopup
                                                            productTags={['generateContract']}
                                                            headertext={t('paymentPopup.headerTexts.generateContract')}
                                                            infotext={
                                                                <span
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: `${t('paymentPopup.suggestTexts.generateContract')} <a href="https://vuokraovi.leea.fi/generateContract" target="_blank">${t('paymentPopup.contract.downloadText')}</a>`
                                                                    }}
                                                                />
                                                            }
                                                            apartment={apartment}
                                                            application={application}
                                                            contract={contract}
                                                        />
                                                    </MuiDialogContent>
                                                </MuiDialog>
                                            </Grid>
                                        </Grid>



                                    </Grid>
                                </Grid>
                                {/* <Button
                                    variant='contained'
                                    color='primary'
                                    className={`${classes.responsiveButton}`}
                                    onClick={handleContractSubmit}
                                >
                                    <Typography variant='h6'>
                                        {t('Log contract data')}
                                    </Typography>
                                </Button>
                                <Button
                                    variant='contained'
                                    color='primary'
                                    className={`${classes.responsiveButton}`}
                                    onClick={generatePDFWithValidation}
                                >
                                    <Typography variant='h6'>
                                        {t('Try validation')}
                                    </Typography>
                                </Button> */}
                            </Grid>
                        )}
                    </>
                )}
            </Grid>
            <style>
                {`
                    input::placeholder {
                        color:  #666666 !important;
                    }
                `}
            </style>
        </form >
    )
}

const selector = formValueSelector('InstantRentForm')

const mapStateToProps = (state: StateInterface) => ({
    readyForMoveDate: selector(state, 'readyForMoveDate'),
    movingWithAmount: selector(state, 'movingWithAmount'),
    acceptedTc: selector(state, 'acceptedTc'),
    contactEmail: selector(state, 'contactEmail'),
    phoneNumber: selector(state, 'phoneNumber'),
    autocompleteLocation: selector(state, 'autocompleteLocation'),
    postalCode: selector(state, 'postalCode'),
    postalArea: selector(state, 'postalArea')
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
    changeFormValue: (field: string, value: string) =>
        dispatch(change('InstantRentForm', field, value)),
    doNextStep: (beforeLogin: boolean) =>
        dispatch(stepAfterShowingForward({ beforeLogin }))
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(
    reduxForm({
        form: 'InstantRentForm'
    })(
        withStyles(styles)(withTranslation()(ContractGeneratorForm as any)) as any
    ) as any
) as any
